class DesignYourPlanMealPicker{
  currencyHandler = new Intl.NumberFormat('en-GB', {style: 'currency',currency: "GBP"});
  customerTypes = {"new":"new", "subscriber":"subscriber"};  
  options = {
    customerType:this.customerTypes.new,
    apiUrl:"https://fuelhub-order.herokuapp.com/design_your_plan/",
    planProducts:{
      onetime:{
        wed:{
          pid:"15144796160373",
          vid:"55599649718645",
        },
        sun:{
          pid:"15144795799925",
          vid:"55599648276853",
        }
      }, 
      subscription:{
        wed:{
          pid:"15144758935925",
          vid:"55599627796853",
          sellingPlan:"710556123509"
        },
        sun:{
          pid:"15144761000309",
          vid:"55599640379765",
          sellingPlan:"710556156277"
        }
      } 
    },
    minMeals:5,
    maxMeals:32,
    preferredMeals:[],
    preferredExtras:[],
    dietary:[],
    goals:[],
    portion:"regular",
    allergies:"No",
    allergies_info:"",
  }
  containers = {};
  filterContainer = null;
  advancedFilterContainer = null;
  orderSummaryContainer = null;
  upsellContainer = null;
  mealsContainer = null;
  extraContainer = null;
  
  upsellDialog= {
    action:"", //what to do next after click ok
    data:"" //data pass to next action after click ok
  };
  data = {
    busy:false,
    meals:[],
    extras:[],
    upsellItems:[],
    type:"subscribe",
    delivery:{date:"", day:""},
    discounts:[],
    shipping_method:"Standard",
    old_shipping_method:"Standard"
    // Temporarily unused — restore with Apply to future orders.
    // apply_future_orders:false
  };
  
  constructor(options, containers) {
    if (options != null){
      this.options.customerType = options?.customerType || this.customerTypes.new;
      this.options.minMeals = options?.minMeals || 5;
      this.options.maxMeals = options?.maxMeals || 32;
      this.options.preferredMeals = options?.preferredMeals || [];
      this.options.preferredExtras = options?.preferredExtras || [];
      this.options.goals = options?.goals || [];
      
    }
    
    this.containers = containers;
    this.initFilter();
    this.initAdvFilter();
    this.initMeals();
    this.initExtra();
    this.initOrderSummary();
    this.initChefSelection();
    this.initUpsell();
  }

  updateOptionsUsingPreferences(preferences){
    // console.log("updateOptionsUsingPreferences 1");
    // console.log(preferences);
    this.options.minMeals = preferences?.number_of_meals || this.options.minMeals;
    this.options.maxMeals = preferences?.max_number_of_meals || this.options.maxMeals;
    this.options.preferredMeals = preferences?.preferred_meals || this.options.preferredMeals;
    this.options.preferredExtras = preferences?.preferred_extras || this.options.preferredExtras;
    this.options.goals = preferences?.goals || this.options.goals;
    this.options.dietary = preferences?.dietary || this.options.dietary;
    if ((this.options.dietary.length > 0)){
      var _dietary = this.options.dietary[0].toLowerCase();
      this.advancedFilterContainer.find(".tag-filter-btn").each(function () {
        if ($(this)?.data("tag")?.toLowerCase() == _dietary){
          $(this).addClass("clicked");
        }     
      });
    }
    
    this.options.portion = preferences?.portion || this.options.portion;
    
    if (this.options.portion == "lite"){
      this.filterContainer.find(".type-filter-btn").each(function () {
        if ($(this)?.data("type")?.toLowerCase() == "low-cal"){
          $(this).addClass("active");
        }     
      });
    }
    // console.log("updateOptionsUsingPreferences 2");
    // console.log(this.options);
    
  }

  
  validateContainer(container){
    var container = $(container);
    if (container.length > 0 ){
      return container;
    } else {
      return null;
    }
  }
  
  
  showAdvFilter(){
    this.advancedFilterContainer.addClass("show");
    $("body").addClass("overflow-y-hidden");
  }
  closeAdvFilter(){
    this.advancedFilterContainer.removeClass("show");
    $("body").removeClass("overflow-y-hidden");
  }
  filterClickHandler(target, type){
    var typeFilterString = [];
    var $this =$(target);
    if (type == "filter"){
      //filter button click
      if ($this.data("type") != "All") {
        this.filterContainer.find(".type-filter-btn-all").removeClass("active");
      
        // if ($this.hasClass("active")){
        //   $this.removeClass("active");
        // } else {
        //   $this.addClass("active");
        // }
        $this.toggleClass("active");
        

        //sync advFitler
        if (["low-cal","high protein","low carb","low fat"].includes($this.data("type"))){
          window.designYourPlan.mealPicker.advancedFilterContainer.find(".tag-filter-btn").each(function () {
            if ($(this).data("tag") == $this.data("type")){
              if ($this.hasClass("active")){
                $(this).addClass("clicked");
              } else {
                $(this).removeClass("clicked");
              }
              
            }
          });
          
        }
        
      } 
      else {
        this.filterContainer.find(".type-filter-btn").removeClass("active");  
        this.advancedFilterContainer.find(".tag-filter-btn").removeClass("clicked");
       
      }

    } else {
      //adv filter button click
      //console.log("adv filter btn click------");
      $this.toggleClass("clicked");
      //sync advFitler
      if (["low-cal","high protein","low carb","low fat"].includes($this.data("tag"))){
        window.designYourPlan.mealPicker.filterContainer.find(".type-filter-btn").each(function () {
          if ($(this).data("type") == $this.data("tag")){
            if ($this.hasClass("clicked")){
              $(this).addClass("active");
            } else {
              $(this).removeClass("active");
            
            }
          }
        });
      }
    }


    //add active filter to typeFilterString array
    this.filterContainer.find(".type-filter-btn").each(function(){
      var $this = $(this);
      if ($this.hasClass("active")){
        if (!typeFilterString.includes($this.data("type"))){
          typeFilterString.push($this.data("type")); 
        }
        
      }
    })

    //add active adv filter to typeFilterString array
    this.advancedFilterContainer.find(".tag-filter-btn").each(function(){
      var $this = $(this);
      if ($this.hasClass("clicked")){
        if (!typeFilterString.includes($this.data("tag"))){
          typeFilterString.push($this.data("tag"));   
        }
        
      }
    })

    
    // console.log(typeFilterString);
    if (typeFilterString.length > 0) {
      typeFilterString = typeFilterString.filter(item => item != "All");

      //console.log(typeFilterString);
      
      $(".meal-list").removeClass("all");
      this.filterContainer.find(".type-filter-btn-all").removeClass("active");

      var nonJuniorFilters = typeFilterString.filter(function (item) {
        return item != "junior";
      });
      var juniorOnly = typeFilterString.includes("junior") && nonJuniorFilters.length === 0;
      if (juniorOnly) {
        $(".meal-list").addClass("all");
      }
      
      
      this.mealsContainer.find(".product-meal-item").each(function () {
        var $this = $(this);
        var mealTags = $this.data("tags");
        let hasAllElemsMatched = true;
        var sortingScore = 0;
        var isInMainMealList = $this.closest(".meal-list").length > 0;

        var numFilters = ["high protein", "low fat", "low-cal", "low carb"];

        for (let i = 0; i < typeFilterString.length; i++) {
          // console.log(typeFilterString[i]);
          // console.log(mealTags);
          // console.log("========================");

          // Junior is an extras filter — do not fail main meal-list items on it.
          if (typeFilterString[i] === "junior" && isInMainMealList) {
            continue;
          }
          
          if (numFilters.includes(typeFilterString[i])){
            var _s = 0;

            if (typeFilterString[i] == "low-cal"){
              _s = parseFloat($this.data("kcal")) || 1000;
              if (_s <= 500){
                sortingScore += (1000 - _s);
              } else {
                hasAllElemsMatched = false;
              }
              
              
            }
            if (typeFilterString[i] == "high protein"){
              _s = parseFloat($this.data("protein")) || 0;
              if (_s >= 20){
                sortingScore += _s + 500;
              } else {
                hasAllElemsMatched = false;
              }
              // console.log($this.data("protein"));
              // console.log(sortingScore);
            }
            if (typeFilterString[i] == "low carb"){
              _s = parseFloat($this.data("carb")) || 1000;
              if (_s <= 40){
                sortingScore += (1000 - _s);
              } else {
                hasAllElemsMatched = false;
              }
            }
            if (typeFilterString[i] == "low fat"){
              _s = parseFloat($this.data("fat")) || 1000;
              
              if (_s <= 10){
                sortingScore += (1000 - _s);
              } else {
                hasAllElemsMatched = false;
              }
            }
          } else {
            if (!mealTags?.includes(typeFilterString[i])) {
              hasAllElemsMatched = false;
            // break;
            } else {
              sortingScore += 100;
            }

          }
          
        }

        if (hasAllElemsMatched) {
          //$this.removeClass("hide");
          //plus 100 if all filter matched
          sortingScore += 10000;
        } else {
          //$this.addClass("hide");
        }

        //set the header title element to right sorting score
        if ($(this).hasClass("filter-matched-heading") || $(this).hasClass("filter-non-matched-heading")){
          $(this).data("sort-score",$(this).data("default-sort-score"));
        } else {
          $(this).data("sort-score",sortingScore);
        }

        
        
      });

      this.matchingNsorting();
    } else {
      $(".meal-list").addClass("all");
      this.filterContainer.find(".type-filter-btn").removeClass("active");  
      this.advancedFilterContainer.find(".tag-filter-btn").removeClass("clicked");
      this.filterContainer.find(".type-filter-btn-all").addClass("active");
      // this.mealsContainer.find(".product-meal-item").each(function () {
      //   var $this = $(this);
      //   $this.removeClass("hide");
      // });
      this.mealsContainer.find(".product-meal-item").each(function () {
        $(this).data("sort-score",$(this).data("default-sort-score"));
      });

      this.matchingNsorting();
    }

    if (type == "filter" && typeFilterString.includes("junior")) {
      // Prefer the active date menu — inactive grids keep .fuelhub-jnr-list in the DOM but hidden.
      var $activeMenu = $(".design-your-plan-meals-grid-wrap.delivery");
      var $juniorList = $activeMenu.find(".fuelhub-jnr-list").first();
      if (!$juniorList.length) {
        $juniorList = $activeMenu.find(".extra-fuel-list").first();
      }
      if (!$juniorList.length) {
        $juniorList = $(".fuelhub-jnr-list:visible").first();
      }
      if (!$juniorList.length) {
        $juniorList = $(".extra-fuel-list:visible").first();
      }
      if ($juniorList.length) {
        setTimeout(function () {
          var el = $juniorList[0];
          var headerOffset = 0;
          var stickyHeader = document.querySelector(".sticky-header") || document.querySelector(".header");
          if (stickyHeader) {
            headerOffset = Math.max(0, stickyHeader.getBoundingClientRect().bottom);
          }
          var gap = 24;
          var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset - gap;
          window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
        }, 100);
      }
    }
  }
  initChefSelection(){
    $(".dyp-chef-selection-container").click(function(){
      window.designYourPlan.mealPicker.autoFill();
    });
  }
  initFilter(){
    this.filterContainer = this.validateContainer(this.containers?.filterContainer);
    if (this.filterContainer == null){
      console.log("Meal Picker filter container not ready");
      return;
    }
    
    // this.filterContainer.find(".tags-filter").click((e) => {
    //   this.showAdvFilter();
    // });

    //add default sort order to all meals
    dypFilterInit();
    
    
    
    /*type filter actions*/
    // this.filterContainer.find(".type-filter-btn").click((e) => {
    //   this.filterClickHandler(e.currentTarget, "filter");
    // });


    /* month date tag  */
    // $(".design-your-plan-menu-date-tab").click(function(){
    //   const idx = $(this).data("idx");
    //   $(".design-your-plan-meals-grid-wrap").removeClass("delivery");
    //   $("#design-your-plan-menu-"+idx).addClass("delivery");

      

    // });
  }
  matchingNsorting(){

    $(".design-your-plan-meals-grid-wrap").each(function (index) {
      
      const productMealItemsContainer = $(this).find(".meal-list");
      const productMealItems = $(productMealItemsContainer).find(".product-meal-item");
      
      //check matching result and display matching header
      const matchedMeals = [];
      const nonMatchedMeals = [];
      
      productMealItems.each(function(){
        if ($(this).hasClass("filter-matched-heading") || $(this).hasClass("filter-non-matched-heading")){
          
        } else if (parseInt($(this).data("sort-score")) >= 10000){
          matchedMeals.push($(this));

        } else {
          nonMatchedMeals.push($(this));
        }
      });
      
      if (matchedMeals.length <= 0){
        $(".filter-matched-heading span").show()
      } else {

        $(".filter-matched-heading span").hide()
      }
      //check matching result and display matching header
      if (nonMatchedMeals.length <= 0){
        $(".filter-non-matched-heading").hide()
      } else {

        $(".filter-non-matched-heading").show()
      }

      $(productMealItemsContainer).append(window.designYourPlan.mealPicker.sortedList(productMealItems));
      

    });

  }
  sortedList(list){
    return list.sort(function (a, b) {
      
      const contentA = parseInt($(a).data("sort-score"));
      const contentB = parseInt($(b).data("sort-score"));
      
      return contentA > contentB ? -1 : contentA < contentB ? 1 : 0;
    });
  }
  
  initAdvFilter(){
    this.advancedFilterContainer = this.validateContainer(this.containers?.advancedFilterContainer);
    if (this.advancedFilterContainer == null){
      console.log("Meal Picker adv filter container not ready");
      return;
    }

    /*advance filter close*/
    // this.advancedFilterContainer.find(".close-filter").click((e) => {
    //   this.closeAdvFilter();
    // });

    // this.advancedFilterContainer.find(".tag-filter-btn").click((e) => {
    //   this.filterClickHandler(e.currentTarget, "advFitler");
    //   // var $this = $(this);
    //   // var tagFilterString = [];
  
    //   // if ($this.hasClass("clicked")) {
    //   //   $this.removeClass("clicked");
    //   // } else {
    //   //   // $this.parents(".filter-group-item").find(".tag-filter-btn").removeClass("clicked");
    //   //   $this.addClass("clicked");
    //   // }

    //   // window.designYourPlan.mealPicker.advancedFilterContainer.find(".tag-filter-btn").each(function () {
    //   //   var $this = $(this);
  
    //   //   if ($this.hasClass("clicked")) {
    //   //     if ($this.data("tag")=="fish"){
    //   //       tagFilterString.push($this.data("tag")+",");
    //   //     } else {
    //   //       tagFilterString.push($this.data("tag"));  
    //   //     }
          
    //   //   } else {
    //   //     tagFilterString = $.grep(tagFilterString, function (value) {
    //   //       return value != $this.data("tag");
    //   //     });
    //   //   }
  
    //   //   window.designYourPlan.mealPicker.mealsContainer.find(".product-meal-item").removeClass("hide");
  
    //   //   if (tagFilterString.length > 0) {
    //   //     window.designYourPlan.mealPicker.mealsContainer.find(".product-meal-item").each(function () {
    //   //       var $this = $(this);
    //   //       var mealTags = $this.data("tags");
    //   //       let hasAllElems = true;
  
    //   //       for (let i = 0; i < tagFilterString.length; i++) {
    //   //         if (!mealTags.includes(tagFilterString[i])) {
    //   //           hasAllElems = false;
    //   //           break;
    //   //         }
    //   //       }
  
    //   //       if (hasAllElems) {
    //   //         $this.removeClass("hide");
    //   //       } else {
    //   //         $this.addClass("hide");
    //   //       }
    //   //     });
    //   //   }
    //   // });

      
    // });
  }
  
  initMeals(){
    this.mealsContainer = this.validateContainer(this.containers?.mealsContainer);
    if (this.mealsContainer == null){
      console.log("Meal Picker meals container not ready");
      return;
    }
    
    // Initialize text for all meals with quantities after a short delay
    setTimeout(() => {
      $(".design-your-plan-meal-qty").each(function() {
        var $this = $(this);
        if ($this.val() > 0) {
          console.log("Late initialization for meal with qty:", $this.val());
          if ($this.val() == 1) {
            //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val() + " meal");
            $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val());
          } else if ($this.val() > 1) {
            //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val() + " meals");
            $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val());
          }
        }
      });
    }, 500);

    $(".product-meal-item .add-to-cart-btn").on("click", function () {
      
      var $this = $(this);    
      var isExtra = $this.parents(".product-meal-item").hasClass("extra-meal");
      if (isExtra || window.designYourPlan.mealPicker.isAllowAddMeal()){
          var mealQty = $this.parents(".product-meal-item").find(".design-your-plan-meal-qty");
      
          mealQty.val(1).trigger("change");
          $this.removeClass("active");
          $this.next().addClass("active");
      }
      
    });

    $(".design-your-plan-qty-selection-wrap .qty-minus").on("click", function (e) {

      
      var mealQty = $(this).parents(".product-meal-item").find(".design-your-plan-meal-qty");
      var qtyVal = mealQty.val();
  
      if (qtyVal > 0) {
        mealQty.val(parseInt(qtyVal) - 1).trigger("change");
  
        if (qtyVal == 1) {
          $(this).parent().removeClass("active");
          $(this).parent().prev().addClass("active");
        } else {
          $(this)
            .next()
            .find(".value")
            .text(parseInt(qtyVal) - 1);
        }
        
        // Update text based on new quantity
        var newQty = parseInt(qtyVal) - 1;
        if (newQty == 1) {
          //$(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meal");
          $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty);
        } else if (newQty > 1) {
          //$(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meals");
          $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty);
        }
        

      }
    });
  
    $(".design-your-plan-qty-selection-wrap .qty-plus").on("click", function () {
      
      var $this = $(this);    
      var isExtra = $this.parents(".product-meal-item").hasClass("extra-meal");
      if (isExtra || window.designYourPlan.mealPicker.isAllowAddMeal()){
      
        
        var mealQty = $(this).parents(".product-meal-item").find(".design-your-plan-meal-qty");
        var qtyVal = mealQty.val();
    
        mealQty.val(parseInt(qtyVal) + 1).trigger("change");
  
        $(this)
          .prev()
          .find(".value")
          .text(parseInt(qtyVal) + 1);
          
        // Update text based on new quantity
        // var newQty = parseInt(qtyVal) + 1;
        // if (newQty == 1) {
        //   $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meal");
        // } else if (newQty > 1) {
        //   $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meals");
        // }
          

      }
    });


    // Added Meals Trigger
    $(".design-your-plan-meal-qty").each(function () {
      var $this = $(this);

      //meal qty change
      var mealQtyCtrler = () => {
        var addedMeal = $this;
        var itemWrap = addedMeal.parent(".product-meal-item");
        var mealVariantID = addedMeal.attr("id");
        var mealTitle = addedMeal.data("title");
        var mealPrice = addedMeal.data("price");
        
        if (addedMeal.val() == 0){
          $this.parent().find(".add-to-cart-btn").addClass("active");
          $this.parent().find(".design-your-plan-qty-selection-wrap").removeClass("active");
        }
        

        
        // Update text based on quantity
        if (addedMeal.val() == 1){
          //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val() + " meal");
          $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val());
        } else if (addedMeal.val() > 1){
          //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val() + " meals");
          $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val());
        }
        
        if (addedMeal.val() <= 1){
          $this.parent().find(".design-your-plan-qty-selection-wrap").find(".value").val("1");
        }
        var isExtra = $this.parents(".product-meal-item").hasClass("extra-meal");
        if (isExtra){
          window.designYourPlan.mealPicker.updateAddedExtras(mealVariantID, mealTitle, mealPrice, addedMeal.val());
        } else {
          window.designYourPlan.mealPicker.updateAddedMeals(mealVariantID, mealTitle, mealPrice, addedMeal.val());
          //dummy meal, for meal not in the menu list testing
          //window.designYourPlan.updateAddedMeals("54905211814261", "Hoisin Chilli Chicken with Egg Noodles & Stir Fry Veg", mealPrice, addedMeal.val());
        }
        
      };
  
      $this.change(function () {
        mealQtyCtrler();
      });
      
      // Initialize text on page load for meals that already have quantity
      setTimeout(() => {
        if ($this.val() > 0) {
          console.log("Initializing text for meal with qty:", $this.val());
          if ($this.val() == 1) {
            //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val() + " meal");
            $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val());
          } else if ($this.val() > 1) {
            //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val() + " meals");
            $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val());
          }
        }
      }, 50);
      

    });

    // console.log('meals', window.designYourPlan.mealPicker.getTotalMeals());
    
  }

  initExtra(){
    this.extraContainer = this.validateContainer(this.containers?.extraContainer);
    if (this.extraContainer == null){
      console.log("Meal Picker extra container not ready");
      return;
    }
    
  }
  
  initOrderSummary(){
    this.orderSummaryContainer = this.validateContainer(this.containers?.orderSummaryContainer);
    if (this.orderSummaryContainer == null){
      console.log("Meal Picker order summary container not ready");
      return;
    }

    
    //init order summary delivery options
    var delivery_dates = $(".plan-day-item");

    function dateString(dateStr) {
      const date = new Date(dateStr);
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      const day = days[date.getDay()];
      const month = months[date.getMonth()];
      const dateNum = date.getDate();
      const suffix = dateNum % 10 === 1 && dateNum !== 11 ? 'st' : dateNum % 10 === 2 && dateNum !== 12 ? 'nd' : dateNum % 10 === 3 && dateNum !== 13 ? 'rd' : 'th';
      return `${day} ${dateNum}${suffix} ${month}`;
    }

    if ($(delivery_dates).length > 0){
      $(delivery_dates).each(function(idx){
        var _dateStr = $(this).data("deliverydate");
        var _dateFullStr = dateString(_dateStr);
        
        //handle dpd easter 5 Apr
        if (_dateFullStr == "Sunday 5th April"){
          _dateFullStr = "Saturday 4th April";
        }
        console.log('_dateStr', _dateStr);
        var option = '<option value="'+_dateStr+'">'+_dateFullStr+'</option>';
        if ($(this).hasClass("active")){
          option = '<option value="'+_dateStr+'" selected>'+_dateFullStr+'</option>';
        }
          
        $(".order-summary-delivery").find(".order-summary-delivery-date").append(option);
      })
    }
    
    $(".order-summary-delivery").find(".order-summary-delivery-date").change(function(){
      
      var newDeliveryDateStr = $(".order-summary-delivery-date").val();
      var newDeliveryDate = new Date(newDeliveryDateStr);
      window.designYourPlan.changeDeliveryDate(newDeliveryDateStr);
      window.designYourPlan.saveData();
      window.designYourPlan.updateUI();
      
    })

    // init order summary discount
    // $("#order-summary-discount-code").blur(function(){
    //   window.designYourPlan.mealPicker.applyDiscountCode($(this).val());
    // });

    $("#order-summary-discount-code").keypress(function (e) {
      if (e.which == 13) {
        window.designYourPlan.mealPicker.applyDiscountCode($(this).val());
        return false;    //<---- Add this line
      }
    });

    $(document).on("click", ".order-summary-discount-code-submit", function(e){
      e.preventDefault();
      e.stopPropagation();
      console.log("Discount submit button clicked");
      window.designYourPlan.mealPicker.applyDiscountCode($("#order-summary-discount-code").val());
      return false;
    });

    $(document).on("change", "input[name='order_summary_shipping_method']", function(){
      if (window.designYourPlan?.mealPicker) {
        window.designYourPlan.mealPicker.data.shipping_method = $(this).val();
        console.log("[shipping-debug] radio changed", {
          value: $(this).val(),
          old_shipping_method: window.designYourPlan.mealPicker.data.old_shipping_method,
          price: window.designYourPlan.mealPicker.getSelectedShippingPrice()
        });
        window.designYourPlan.mealPicker.updateUI();
      }
    });

    // Temporarily unused — restore with Apply to future orders.
    // $(document).on("change", "#order_summary_apply_future_orders", function(){
    //   if (window.designYourPlan?.mealPicker) {
    //     window.designYourPlan.mealPicker.data.apply_future_orders = $(this).is(":checked");
    //   }
    // });

    $(".order-summary-preview").click(function(){
      //skip upsell
      window.designYourPlan.mealPicker.checkout();
      return;
      
      //console.log("order-summary-preview click");
      
      
      // if ((typeof window.abTest != 'undefined') && window.abTest == "b"){
      //   //console.log(window.abTest);
      //   window.designYourPlan.mealPicker.checkout();
      //   return;
      // }

      // skip upsell if window height less than 650;
      if ($(window).height() <= 650){
        window.designYourPlan.mealPicker.checkout();
        return;
      }
        
      if (typeof window.designYourPlan.mealPicker.options.customerType != 'undefined' && window.designYourPlan.mealPicker.options.customerType == "subscriber") {
        console.log("--->subscriber");
        
        const totalMeals = window?.designYourPlan?.mealPicker?.getTotalMeals() || 0;
        const minMeals = window?.designYourPlan?.mealPicker?.options?.minMeals || 5;
        const mealsRemain = minMeals - totalMeals;
        
        // console.log("totalMeals: "+totalMeals);
        // console.log("minMeals: "+totalMeals);
        
        if (mealsRemain > 0) {
          return false;
        } else {
          window.designYourPlan.mealPicker.handleUpsell();
          //window.designYourPlan.mealPicker.checkout();
        }
      } else {
        console.log("--->new customer");
        window.designYourPlan.mealPicker.handleUpsell();
          
      }
        
      return;

      //end

      
      if (typeof window.dyp_customer_type === 'undefined') {
        // variable is undefined
        const totalMeals = window.designYourPlan.mealPicker.getTotalMeals();
        const mealsRemain = window.designYourPlan.mealPicker.options.minMeals - totalMeals;
        // console.log(totalMeals);
        // console.log(upsellValue);
        
        if (mealsRemain > 0) {
          return false;
        } else {
          //window.designYourPlan.mealPicker.handleUpsell();
          window.designYourPlan.mealPicker.checkout();
        }
        return;
        
      }
      
      //check new customer
      var _totalMeals = 5;
      // if (typeof window.designYourPlan.mealPicker.getTotalMeals === "function") { 
      //   _totalMeals = window.designYourPlan.mealPicker.getTotalMeals();
      // } else {
      //   _totalMeals = 5;
      // }
      
      if (_totalMeals >= 5){
        window.designYourPlan.mealPicker.checkout();
      } else {
        return false;
      }
      


      // const totalMeals = window.designYourPlan.mealPicker.getTotalMeals();

      
      // if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
      //   //new customer 
      //   if (totalMeals >= 5){
      //     window.designYourPlan.mealPicker.checkout();
      //   } else {
      //     return false;
      //   }
      //   return false;
      // }
      
      // const mealsRemain = window.designYourPlan.mealPicker.options.minMeals - totalMeals;
      // // console.log(totalMeals);
      // // console.log(upsellValue);
      
      // if (mealsRemain > 0) {
      //   return false;
      // } else {
      //   //window.designYourPlan.mealPicker.handleUpsell();
      //   window.designYourPlan.mealPicker.checkout();
      // }
    });

    $(".order-type-content").click(function(){
      
      $(".order-type-content").removeClass("active");
      $(this).addClass("active");

      
      window.designYourPlan.mealPicker.data.type = $(this).data("type");
      window.designYourPlan.saveData();
      window.designYourPlan.updateUI();
    });

    $(".meal-autofill").click(function(){
      window.designYourPlan.mealPicker.autoFill();
    });
  }
  
  initUpsell(){
    
    this.upsellContainer = this.validateContainer(this.containers?.upsellContainer);
    if (this.upsellContainer == null){
      console.log("Meal Picker upsell container not ready");
      return;
    }
  }


  /*get plan data*/
  getPlanData(){
    return this.data;
  }
  setPlanData(data){
    this.data = data;
    this.verifyNRestoreSavedData();
  }
  verifyNRestoreSavedData(){
    //verify and restore added meals
    // console.log("verifyNRestoreSavedData");
    var activeMenuObj = $(".design-your-plan-meals-grid-wrap.delivery");
    
    //const mealsToVerify = [...this?.data?.meals].reverse();
    const mealsToVerify = JSON.parse(JSON.stringify(this?.data?.meals)).reverse();

    

    
    if (mealsToVerify != null && mealsToVerify.length > 0 ){
      mealsToVerify.forEach((meal, idx) => {
        if ($(activeMenuObj).find("#"+meal.vid).length > 0){
          //meal found in the active menu list
          $(activeMenuObj).find("#"+meal.vid).each(function(){
            $(this).val(meal.qty);
            $(this).parent().find(".add-to-cart-btn").removeClass("active");
            $(this).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
            //$(this).parent().find(".design-your-plan-qty-selection-wrap").find(".value").html(meal.qty);
            
            if (meal.qty == 1){
              //$(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(meal.qty + " meal");
              $(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(meal.qty);
            } else if (meal.qty > 1){
              //$(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(meal.qty + " meals");
              $(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(meal.qty);
            }


          });  
        } else {
          //remove from saved meals list
          this.data.meals.splice((mealsToVerify.length - 1 - idx), 1);
        }
      })
      if (!this.isAllowAddMeal()){
        $(".main-meal-selection .design-your-plan-meals-grid-wrap .meal-add-cart").addClass("add-more-disabled");
        $(".added-detail-summary").addClass("add-more-disabled");
      }
    } else {
      this.data.meals = [];
    }

    //const extrasToVerify = [...this?.data?.extras].reverse();
    const extrasToVerify = JSON.parse(JSON.stringify(this?.data?.extras)).reverse();

    if (extrasToVerify != null && extrasToVerify.length > 0){
      // console.log("extrasToVerify");
      // console.log(extrasToVerify);
      extrasToVerify.forEach((extra, idx) => {
        if ($(activeMenuObj).find("#"+extra.vid).length > 0){
          //extra found in the menu list
          $(activeMenuObj).find("#"+extra.vid).each(function(){
            $(this).val(extra.qty);
            $(this).parent().find(".add-to-cart-btn").removeClass("active");
            $(this).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
            //$(this).parent().find(".design-your-plan-qty-selection-wrap").find(".value").html(extra.qty);
            if (extra.qty == 1){
              //$(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(extra.qty + " meal");
              $(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(extra.qty);
            } else if (extra.qty > 1){
              //$(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(extra.qty + " meals");
              $(this).parent().find(".design-your-plan-qty-selection-wrap .bold").text(extra.qty);
            }

          });  
        } else {
          //remove from saved extra list
          this.data.extras.splice((extrasToVerify.length - 1 - idx), 1);
        }
      })  
    } else {
      this.data.extras = [];
    }

    if (this.options.customerType == this.customerTypes.new){
      this.data.discounts = [];
    }
  }
  

  /*UI update*/
  updateUI(){
    console.log(">>>>> meal picker update UI");
    console.log(this.options);
    console.log(this.data);
    // this.updateMealCounter();
    console.log("this.options.goals");
    console.log(this.options.goals);
    if (this.options.goals.length == 0){
      $("#type-filter-btn-goals").removeClass("actice");
      $("#type-filter-btn-goals").hide();
    } else {
      $("#type-filter-btn-goals").show();
    }

    $(".main-meal-selection").removeClass("type-subscribe");
    $(".main-meal-selection").removeClass("type-one-time");
    $(".main-meal-selection").addClass("type-"+this.data.type);
    
    if (this.data.type == "one-time"){
      $(".design-your-plan-num-of-meals-title").html("From £8.5 per meal. Choose 5–32 meals (10 is our most popular plan).");
    } else {
      $(".design-your-plan-num-of-meals-title").html("From £8 per meal. Choose 5–32 meals (10 is our most popular plan).");
    }

    this.updateOrderSummaryUI();
    console.log(">>>>> end meal picker update UI");
    
  }
  
  updateMealCounter(){
    const totalMeals = this.getTotalMeals();
    const lastMeals = $(".order-summary-container-meal-counter span:first").data("total_meals");
    $(".order-summary-container-meal-counter span:first").text(totalMeals);
    $(".order-summary-container-meal-counter span:nth-child(2)").text((totalMeals == 1)?"Meal":"Meals");
    if (lastMeals != totalMeals){
      $(".order-summary-container-meal-counter span:first").addClass("fade-in");
      setTimeout(function(){
        $(".order-summary-container-meal-counter span:first").removeClass("fade-in");
      }, 300);
    }
    $(".order-summary-container-meal-counter span:first").data("total_meals", totalMeals);
    //console.log("Meal counter updated to:", totalMeals);

    $(".order-summary-container-meal-counter span:nth-child(3)").hide();
    $(".order-summary-container-meal-counter span:nth-child(4)").hide();
    $(".order-summary-container-meal-counter span:nth-child(5)").hide();
    
    const totalExtras = this.data.extras ? this.data.extras.reduce((acc, extra) => acc + parseInt(extra.qty), 0) : 0;
    if (totalExtras >= 1){
      const lastExtras = $(".order-summary-container-meal-counter span:nth-child(4)").data("total_extras");
    
      $(".order-summary-container-meal-counter span:nth-child(4)").text(totalExtras);
      $(".order-summary-container-meal-counter span:nth-child(5)").text((totalExtras == 1)?"Extra":"Extras");
      
      $(".order-summary-container-meal-counter span:nth-child(3)").show();
      $(".order-summary-container-meal-counter span:nth-child(4)").show();
      $(".order-summary-container-meal-counter span:nth-child(5)").show();
      if (lastExtras != totalExtras){
        $(".order-summary-container-meal-counter span:nth-child(4)").addClass("fade-in");
        setTimeout(function(){
          $(".order-summary-container-meal-counter span:nth-child(4)").removeClass("fade-in");
        }, 300);
      }
      $(".order-summary-container-meal-counter span:nth-child(4)").data("total_extras", totalExtras);
    
    }

    
  }
  updateNutritionalCalculator(){
    const totalMeals = this.getTotalMeals();
    $(".dyp-menu-date-wrapper-info-goals").html("Your Goals: <b>"+this.options.goals.join(", "))+"</b>";
    if (this.options.goals.length > 0){
      $(".dyp-menu-date-wrapper-info-goals").show();
    } else {
      $(".dyp-menu-date-wrapper-info-goals").hide();
    }
    if (totalMeals == 0){
      $(".dyp-menu-date-wrapper-info-text").html("<span></span>Please select a minimum of <b>"+this.options.minMeals+"</b> meals to complete your order.");
      $(".dyp-menu-date-wrapper-info-text span:first").text("");
      
    } else {
      var _msg_text="meal selected";
      if (totalMeals > 1){
        _msg_text="meals selected";
      }
      if (this.options.goals.length > 0){
        _msg_text +=" based on your preferences";
      }
      $(".dyp-menu-date-wrapper-info-text").html("<span></span> "+_msg_text+" (minimum "+this.options.minMeals+" meals)");
      $(".dyp-menu-date-wrapper-info-text span:first").text(totalMeals);
      
    }
    $(".dyp-menu-date-wrapper-info-cals").html("");
    
    if (totalMeals > 0){
      const nutritionalInfo = this.getTotalNutritionalInfo();
      //console.log(nutritionalInfo);
      //$(".dyp-menu-date-wrapper-info-cals span:first").text("1,000");
      const avgCal = parseFloat(nutritionalInfo.meals.calorie) / parseInt(nutritionalInfo.meals.total) ;
      const avgProtein = parseFloat(nutritionalInfo.meals.protein) / parseInt(nutritionalInfo.meals.total) ;
      const avgFat = parseFloat(nutritionalInfo.meals.fat) / parseInt(nutritionalInfo.meals.total) ;
      const avgCarb = parseFloat(nutritionalInfo.meals.carb) / parseInt(nutritionalInfo.meals.total) ;

      //$(".dyp-menu-date-wrapper-info-cals").html(`<span>av. ${avgCal.toFixed(0)}Kcal, ${avgProtein.toFixed(0)}g Protein, ${avgCarb.toFixed(0)}g Carb, ${avgFat.toFixed(0)}g Fat per meal</span>`);
      $(".dyp-menu-date-wrapper-info-cals").html(`<span>av. ${avgCal.toFixed(0)}Kcal, ${avgProtein.toFixed(0)}g Protein per meal</span>`);
    }
  }
  updateOrderSummaryUI(){
    function updateOrderSummaryHeight(){
      if ($(window).width() > 1024) {
        const windowHeight = $(window).height();
        const announcementHeight = $('.announcement-container').height();
        const headerHeight = $('.shopify-section-group-header-group').height();
        const stickyNavHeight = $('.design-your-plan__progress_list').height();
        const elementsHeight = announcementHeight + headerHeight + stickyNavHeight;
        const desiredSummaryHeight = windowHeight - elementsHeight;

        $('.order-summary-container-inner').css('height', desiredSummaryHeight - (windowHeight * 0.1) + 'px');
      } else {
        $('.order-summary-container-inner').css('height', 'auto');
      }
    }

    updateOrderSummaryHeight();

    $(window).resize(function(){
      updateOrderSummaryHeight();
    });

    this.updateMealCounter();
    this.updateNutritionalCalculator();
    

    // console.log("delivery date:");
    // console.log(this.data.delivery);
    $(".order-summary-delivery-date").val(this.data.delivery.date);

    // //init order summary delivery options
    // var delivery_dates = $(".plan-day-item");
    // if ($(delivery_dates).length > 0){
    //   $(delivery_dates).each(function(idx){
    //     var _dateStr = $(this).data("deliverydate");
    //     var option = '<option value="'+_dateStr+'">'+_dateStr+'</option>';
    //     if ($(this).hasClass("active")){
    //       option = '<option value="'+_dateStr+'" selected>'+_dateStr+'</option>';
    //     }
          
    //     $(".order-summary-delivery").find(".order-summary-delivery-date").append(option);
    //   })
    // }

    $(".dyp-menu-date-wrapper-date-day").html(this.data.delivery.day);
    $(".dyp-menu-date-wrapper-date-month").html(moment(this.data.delivery.date).format('DD MMM'));
    if (moment(this.data.delivery.date).format('MMM') == "Sep"){
      $(".dyp-menu-date-wrapper-date-month").html(moment(this.data.delivery.date).format('DD') + " Sept");  
    }
    if (moment(this.data.delivery.date).format('MMM') == "Jun"){
      $(".dyp-menu-date-wrapper-date-month").html(moment(this.data.delivery.date).format('DD') + " June");  
    }
    
    $(".added-detail-summary").removeClass("subscribe");
    $(".added-detail-summary").removeClass("one-time");
    $(".added-detail-summary").addClass(this.data.type);
    
    $(".order-summary-container-inner").removeClass("subscribe");
    $(".order-summary-container-inner").removeClass("one-time");
    $(".order-summary-container-inner").addClass(this.data.type);

    
    $(".discounts label .code").html("");
    //console.log(this.data.meals);
    $(".order-type-content").removeClass("active");
    if (this.data.type == "one-time"){
      $(".order-type-content.onetime").addClass("active");
    } else {
      $(".order-type-content.subscription").addClass("active");
      // $(".order-type-content.subscription").hide();
    }
    
    if (this.data.meals.length <= 0 && this.data.extras.length <= 0){
      $(".order-summary-preview").addClass("disabled");
        
      $(".empty-summary").removeClass("hidden");
      $(".added-detail-summary").addClass("hidden");
      
      $(".order-summary-container-inner").removeClass("meals-selected");
      $(".detail-lists .meal-detail-lists").html("");
      $(".detail-lists .extra-detail-lists").html("");
      
      $(".your-plan-discount").hide();
      $(".order-summary-up-sell").hide();
      //$(".order-summary-up-sell").html('Please choose your meals to complete your box.');  
      $(".meal-detail-lists").html("Please choose your meals to complete your weekly order. Most select 10 per week, you'll need a minimum of <b>"+this.options.minMeals+"</b>.");  
      $(".dyp-chef-selection-container").show();

      if (this.options.customerType == this.customerTypes.subscriber){
        //$(".order-summary-discount .code .order-summary-discount-code-container").hide();
        //$(".order-summary-discount").hide();
        $(".order-summary-discount").html("<div class='discount-cal-later'>Discount will be calculated after you save your meals.</div>");
        $(".order-summary-discount").show();
        
        
      }
      $(".total-lists").html("");
      
    } else {
      $(".empty-summary").addClass("hidden");
      $(".added-detail-summary").removeClass("hidden");
      $(".order-summary-container-inner").addClass("meals-selected");
      $(".detail-lists .meal-detail-lists").html("");
      $(".detail-lists .extra-detail-lists").html("");
      $(".order-summary-up-sell").show();
      if (window.designYourPlan.mealPicker.data.type == "subscribe"){
        $(".your-plan-discount").css({"display":"flex"});
      } else {
        $(".your-plan-discount").css({"display":"none"});
      }
      $(".dyp-chef-selection-container").hide();

      if (this.isReachMin()){
        $(".order-summary-preview").removeClass("disabled");
        $(".order-summary-up-sell").html('On average, our customers choose <b>10 x meals</b>. Our minimum meal quantity is 5.'); 
        //$(".order-summary-up-sell").html('');  

      } else {
        $(".order-summary-preview").addClass("disabled");
        //$(".order-summary-up-sell").html('Add <span class="value h4">'+(this.options.minMeals-this.getTotalMeals())+'</span> more meals to complete your order');  
        $(".order-summary-up-sell").html('Please add a minimum of <span class="value h4">'+(this.options.minMeals-this.getTotalMeals())+'</span> more meal'+(((this.options.minMeals-this.getTotalMeals()) >1)?"s":"")+' to complete your order.');  
        
        
      }
      
      $(".meal-detail-lists-header").hide();
      var mealsDetailsHTML = this.data.meals.map((meal) => {
        $(".meal-detail-lists-header").show();
        var _mealObject = this.findMealObject(false, meal.vid);
        var _mealObject = $(".design-your-plan-meals-grid-wrap.delivery").find("#"+meal.vid);
        var mealDetails = {title:_mealObject.data("title"), price:_mealObject.data("price"), image:$(_mealObject).parent().find(".meal-img-box").find("img").attr("src")}
        
        var _itemTotal = parseFloat(mealDetails.price)*parseInt(meal.qty);
        var _itemTotalText = this.currencyHandler.format(_itemTotal);
        //if (this.options.customerType == this.customerTypes.subscriber){
        if (this.data.type == "subscribe"){
          var _discountedItemTotal = parseFloat(_itemTotal) - (0.5 * parseFloat(meal.qty));
          // use discounted price
          _itemTotalText = '<span class="crossed-out">'+this.currencyHandler.format(_itemTotal)+'</span>'+this.currencyHandler.format(_discountedItemTotal);
          console.log("_itemTotalText: "+_itemTotalText);
          // use original price
          //_itemTotalText = this.currencyHandler.format(_discountedItemTotal);
        }
        return '<div class="meal"><div class="meal_img"><div class="qty">'+meal.qty+'</div></div><div class="meal_title_qty"><div class="meal_title" onclick="window.designYourPlan.mealPicker.gotoMeal('+meal.vid+')">'+mealDetails.title+'</div><div class="qty-btn"><div class="qty-minus" onclick="window.designYourPlan.mealPicker.orderSummayMinusHandle('+meal.vid+')">-</div><div class="qty-val">'+meal.qty+'</div><div class="qty-plus" onclick="window.designYourPlan.mealPicker.orderSummayPlusHandle('+meal.vid+')">+</div></div></div><div class="meal_price">£'+mealDetails.price+'</div><div class="meal_qty">x'+meal.qty+'</div><div class="meal_total">'+_itemTotalText+'</div></div>'
      }).join("");

      
      $(".extra-detail-lists-header").hide();
      var extrasDetailsHTML = this.data.extras.map((meal) => {
        
        $(".extra-detail-lists-header").show();
        var _mealObject = this.findMealObject(true, meal.vid);
        var mealDetails = {title:_mealObject.data("title"), price:_mealObject.data("price"), image:$(_mealObject).parent().find(".meal-img-box").find("img").attr("src")}
        
        var _itemTotal = parseFloat(mealDetails.price)*parseInt(meal.qty);
        var _itemTotalText = this.currencyHandler.format(_itemTotal);
        if (window.designYourPlan.mealPicker.data.type == "subscribe"){
          // use discounted price
          _itemTotalText = '<span class="crossed-out"></span>'+this.currencyHandler.format(_itemTotal);
          
          // use original price
          //_itemTotalText = this.currencyHandler.format(_itemTotal);
        }
        return '<div class="meal"><div class="meal_img"><div class="qty">'+meal.qty+'</div></div><div class="meal_title_qty"><div class="meal_title" onclick="window.designYourPlan.mealPicker.gotoMeal('+meal.vid+')">'+mealDetails.title+'</div><div class="qty-btn"><div class="qty-minus" onclick="window.designYourPlan.mealPicker.orderSummayExtraMinusHandle('+meal.vid+')">-</div><div class="qty-val">'+meal.qty+'</div><div class="qty-plus" onclick="window.designYourPlan.mealPicker.orderSummayExtraPlusHandle('+meal.vid+')">+</div></div></div><div class="meal_price">£'+mealDetails.price+'</div><div class="meal_qty">x'+meal.qty+'</div><div class="meal_total">'+_itemTotalText+'</div></div>'
      }).join("");



      
    const totalExtras = this.data.extras ? this.data.extras.reduce((acc, extra) => acc + parseInt(extra.qty), 0) : 0;

    const totalMeals = this.getTotalMeals();
    var _totalMealExtraCountText = "";
    if (totalMeals > 0){
      _totalMealExtraCountText = "<span>"+totalMeals+"</span> "+(totalMeals==1?" Meal":" Meals")+"";
    }
    if (totalExtras > 0){
      if (_totalMealExtraCountText != ""){
        _totalMealExtraCountText+= ", ";
      }
      _totalMealExtraCountText += "<span>"+totalExtras+"</span> "+(totalExtras==1?" Extra":" Extras")+"";
    }
    $(".total-lists").html("Total: " +_totalMealExtraCountText);
    // $(".total-lists").find("span").addClass("fade-in");
    // setTimeout(function(){
    //   $(".total-lists").find("span").removeClass("fade-in");
    // }, 300);
      
      $(".detail-total-container .discounts .code").html("");
      var allowMoreDiscount = true;
      if (this.data.discounts != null && this.data.discounts.length >0){
        //product discount first
        $.each(this.data.discounts, function( index, value ) {
          if (value.discountClass == "PRODUCT"){
            window.designYourPlan.mealPicker.genDiscountText(value);

            if (!value.combinesWith.orderDiscounts){
              allowMoreDiscount = false;
            }
          }
        });
        // order discount
        $.each(this.data.discounts, function( index, value ) {
          if (value.discountClass == "ORDER"){
            window.designYourPlan.mealPicker.genDiscountText(value);
          }
        });

        if (this.options.customerType == this.customerTypes.subscriber){
          if (this.data.discounts.length >=1){
            allowMoreDiscount = false;
          }
        } else {
          if (this.data.discounts.length >=2){
            allowMoreDiscount = false;
          }
        }
        
        
        
      }

      if (allowMoreDiscount){
        $("#order-summary-discount-code").prop('disabled', false);
        $(".order-summary-discount-code-submit").prop('disabled', false);

      } else {
        $("#order-summary-discount-code").prop('disabled', true);
        $(".order-summary-discount-code-submit").prop('disabled', true);
      }

      if (this.options.customerType == this.customerTypes.subscriber){
        //$(".order-summary-discount .code .order-summary-discount-code-container").hide();
        //$(".order-summary-discount").hide();
        
        $(".order-summary-discount").html("<div class='discount-cal-later'>Discount will be calculated after you save your meals.</div>");
        $(".order-summary-discount").show();
        
      }


      const caledPricing = this.calTotal();
      console.log('caledPricing', caledPricing);

      function twoDec(number) {
        return number.toFixed(2);
      }

      console.log('twoDec(caledPricing.subTotal)', twoDec(caledPricing.subTotal));
      $('.order-summary-delivery-upsell .your-plan-price').html('£' + twoDec(caledPricing.total + caledPricing.shipping));
      $('.order-summary-delivery-upsell .your-plan-price.crossed-out').html('£' + twoDec(caledPricing.subTotal + caledPricing.shipping));
      // $('.your-plan-discount-amount').html('£' + twoDec(caledPricing.finalDiscount));
      
      $(".detail-lists .meal-detail-lists").html(mealsDetailsHTML);
      $(".detail-lists .extra-detail-lists").html(extrasDetailsHTML);


      $(".sub-total .val").html(this.currencyHandler.format(caledPricing.subTotal));
      
      $(".discounts .val").html("-"+this.currencyHandler.format( (parseFloat(caledPricing.finalDiscountDiscountOnly)) ));
      //$(".discounts .val").html("-"+this.currencyHandler.format( (parseFloat(caledPricing.orderDiscount + caledPricing.productDiscount)) ));


      
      $(".total .val").html(this.currencyHandler.format(caledPricing.total));

      $(".order-type-content.subscription").find(".save").html("Save "+this.currencyHandler.format( (parseFloat(caledPricing.finalDiscount)) ));
      
      if (this.options.customerType == this.customerTypes.new){
        if (this.data.type == "one-time"){
          $(".order-summary-discount").hide();  
        } else {
          $(".order-summary-discount").show(); 
        }
      }
      
          
      
      if (caledPricing.finalDiscountDiscountOnly <= 0 ){
        $(".your-plan-discount").hide();
        $(".order-summary-delivery-upsell-first-week-total-price .crossed-out").hide();
      } else {
        //alert(this?.data?.discounts);
        //alert(this.options.customerType);
        //if (this.options.customerType == this.customerTypes.subscriber){
        if (this.data.type == "subscribe"){
          //if (this?.data?.discounts?.length > 0){
            $(".your-plan-discount").show();
            
            // how much subscribe saved
            // $(".your-plan-discount p").html("Discount: "+(
            //   this.data.type == "subscribe"?"<div><span class='code no-del'>Subscription (-"+this.currencyHandler.format(caledPricing.subscribeDiscount)+")</span></div>":""
            // )
            $(".your-plan-discount p").html("Discount: "+this?.data?.discounts?.map((d) => {
              
              if (d.discountClass == "PRODUCT"){
                var discountText = d.code;
                if (d.customerGets.value.__typename == "DiscountAmount"){
                  discountText = "-£"+d.customerGets.value.amount.amount;
                  
                }
                if (d.customerGets.value.__typename == "DiscountPercentage"){
                  discountText = (parseFloat(d.customerGets.value.percentage)*100)+"% off";
                }

                return '<div><span class="code">'+d.code+'('+discountText+')<span class="del" onclick="window.designYourPlan.mealPicker.removeDiscountCode(this, \''+d.code+'\')"></span></span></div>'
              } else {
                return "";
              }
            }).join("")+this?.data?.discounts?.map((d) => {
              if (d.discountClass == "ORDER"){
                var discountText = d.code;
                if (d.customerGets.value.__typename == "DiscountAmount"){
                  discountText = "-£"+d.customerGets.value.amount.amount;
                  
                }
                if (d.customerGets.value.__typename == "DiscountPercentage"){
                  discountText = (parseFloat(d.customerGets.value.percentage)*100)+"% off";
                }

                return '<div><span class="code">'+d.code+'('+discountText+')<span class="del" onclick="window.designYourPlan.mealPicker.removeDiscountCode(this, \''+d.code+'\')"></span></span></div>'
              } else {
                return "";
              }
            }).join(""));
            

            //$(".detail-total-container .discounts .code").append('<div>'+discount.code+' ('+discountText+')<span class="del" onclick="window.designYourPlan.mealPicker.removeDiscountCode(this, \''+discount.code+'\')"></span></div>');

            
            //$(".your-plan-discount p").html("Discount: ") ;
          //} else {
            //$(".your-plan-discount p").html("Discount: ") ;
            //$(".your-plan-discount").hide();
          //}
        }
        //$(".your-plan-discount").show();
        
        if (this.data.type == "one-time"){
        
          $(".order-summary-delivery-upsell-first-week-total-price .crossed-out").hide();
        } else {
          $(".order-summary-delivery-upsell-first-week-total-price .crossed-out").show();
        }
        
      }

      
    }
    // end update meals, list pricing, discount

    

    if (window.designYourPlan.mealPicker.data.type == "subscribe"){
      if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
        $(".order-summary-delivery").find(".text").html("Your First Delivery");
      
      } else {
        $(".order-summary-delivery").find(".text").html("Your Delivery");
      
      }
      $(".order-summary-your-plan").find(".title").html("Your Flexible Weekly Plan");
    } else {
      $(".order-summary-delivery").find(".text").html("Your Delivery");
      $(".order-summary-your-plan").find(".title").html("Your One-Time Box");
    }

    
  }
  findMealObject(isExtra, vid){
    if (isExtra){
      //return $(".extra-meal-selection").find("#"+vid);
      return $(".design-your-plan-meals-grid-wrap.delivery").find("#"+vid);
    }
    return $(".design-your-plan-meals-grid-wrap.delivery").find("#"+vid);
  }

  getSelectedShippingMethod(){
    if (this.options.customerType == this.customerTypes.subscriber){
      var selected = $("input[name='order_summary_shipping_method']:checked").val();
      if (selected === "Standard" || selected === "Priority") {
        this.data.shipping_method = selected;
        return selected;
      }
      return this.data.shipping_method || "Standard";
    }
    return "Standard";
  }

  getSelectedShippingPrice(){
    return this.getSelectedShippingMethod() === "Priority" ? 9.95 : 6.95;
  }

  // Temporarily unused — restore with Apply to future orders.
  // isApplyFutureOrdersChecked(){
  //   if (this.options.customerType != this.customerTypes.subscriber){
  //     return false;
  //   }
  //   var checked = $("#order_summary_apply_future_orders").is(":checked");
  //   this.data.apply_future_orders = checked;
  //   return checked;
  // }
  isApplyFutureOrdersChecked(){
    return false;
  }

  setOrderSummaryShippingUI(shippingMethod, applyFutureOrders){
    var method = shippingMethod === "Priority" ? "Priority" : "Standard";
    this.data.shipping_method = method;
    this.data.old_shipping_method = method;
    // Temporarily unused — restore with Apply to future orders.
    // this.data.apply_future_orders = !!applyFutureOrders;
    $("input[name='order_summary_shipping_method'][value='" + method + "']").prop("checked", true);
    // $("#order_summary_apply_future_orders").prop("checked", !!applyFutureOrders);
  }

  calTotal(){
    const _mealTotalQty = this.data.meals.reduce(
      (accumulator, currentValue) => {
        return accumulator + parseInt(currentValue.qty);
      },
      0,
    );
    const _mealSubTotal = this.data.meals.reduce(
      (accumulator, currentValue) => {
        var _mealObject = this.findMealObject(false, currentValue.vid);
        var _itemTotal = parseFloat($(_mealObject).data("price"))*parseInt(currentValue.qty);
        
        //subs meal discount
        if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.subscriber){
          _itemTotal = (parseFloat($(_mealObject).data("price")) - 0.5)*parseInt(currentValue.qty);
        }
        return accumulator + _itemTotal
      },
      0,
    );
    const _extraTotalQty = this.data.extras.reduce(
      (accumulator, currentValue) => {
        return accumulator + parseInt(currentValue.qty);
      },
      0,
    );
    const _extraSubTotal = this.data.extras.reduce(
      (accumulator, currentValue) => {
        var _mealObject = this.findMealObject(true, currentValue.vid);
        var _itemTotal = parseFloat($(_mealObject).data("price"))*parseInt(currentValue.qty);
        return accumulator + _itemTotal
      },
      0,
    );
    var _subscribeDiscount = 0;
    var _productDiscount = 0;
    var _orderDiscount = 0;
    const _subTotal = _mealSubTotal + _extraSubTotal;
    var _subTotalAfterDiscount = _subTotal;
    var _subTotalWithoutExtrasAfterDiscount = _mealSubTotal;

    var _shipping = this.getSelectedShippingPrice();
    //cal discount
    //if (this.data.type == "subscribe"){
      //discount only for subscribe
        //_subscribeDiscount = parseFloat((parseFloat(_subTotal) * 0.05).toFixed(2));
      console.log("_mealTotalQty: "+_mealTotalQty);
      _subscribeDiscount = _mealTotalQty*0.5;
      
      //subs meal discount
      if (this.options.customerType == this.customerTypes.subscriber){
        _subscribeDiscount = 0;
      }
        _subTotalAfterDiscount = _subTotal - _subscribeDiscount;
        _subTotalWithoutExtrasAfterDiscount -= _subscribeDiscount;
        if (this.data.discounts != null && this.data.discounts.length >0){
          //product discount first
          $.each(this.data.discounts, function( index, value ) {
              var discountText = value.code;
              if (value.discountClass == "PRODUCT"){

                // product discount only apply to meals
                if (value.customerGets.value.__typename == "DiscountAmount"){
                  _productDiscount = parseFloat(value.customerGets.value.amount.amount);

                  if (_productDiscount >= _subTotal){
                    _productDiscount = _subTotalWithoutExtrasAfterDiscount;
                  }

                }
                if (value.customerGets.value.__typename == "DiscountPercentage"){
                  // only apply to meals
                  _productDiscount = parseFloat((_subTotalWithoutExtrasAfterDiscount * parseFloat(value.customerGets.value.percentage)).toFixed(2));
                  //console.log(window.designYourPlan.mealPicker.options.customerType+" : "+_subscribeDiscount+" : "+_mealSubTotal+" : " +value.customerGets.value.percentage+" : "+_productDiscount);
                }
              }
              
              
          });

          // order amount discount
          _subTotalAfterDiscount = _subTotal - _subscribeDiscount - _productDiscount;
          _subTotalWithoutExtrasAfterDiscount = _subTotal - _extraSubTotal - _subscribeDiscount - _productDiscount;
          $.each(this.data.discounts, function( index, value ) {
            if (value.discountClass == "ORDER"){
              if (value.customerGets.value.__typename == "DiscountAmount"){
                _orderDiscount = parseFloat(value.customerGets.value.amount.amount);
              }
              if (value.customerGets.value.__typename == "DiscountPercentage"){
                if (value.code.toLowerCase() == "welcome20"){
                  _orderDiscount = parseFloat((_subTotalAfterDiscount * parseFloat(value.customerGets.value.percentage)).toFixed(2));
                } else {
                  _orderDiscount = parseFloat((_subTotalWithoutExtrasAfterDiscount * parseFloat(value.customerGets.value.percentage)).toFixed(2));
                }
                
              }
            }
            
          });
        }
    //}
    
    // with subs discount
    var _finalDiscount = _subscribeDiscount + _productDiscount + _orderDiscount;
    var _finalDiscountDiscountOnly = _productDiscount + _orderDiscount;
    
    //var _finalDiscount = _productDiscount + _orderDiscount;
    

    if (_finalDiscount >= _subTotal){
      _finalDiscount = _subTotal;
    }
    var _total = _subTotal;
    if (this.data.type == "subscribe"){
      _total = _subTotal - _finalDiscount;
    }
    return {total:_total, shipping:_shipping, subTotal:_subTotal, productDiscount:_productDiscount, orderDiscount:_orderDiscount, subscribeDiscount:_subscribeDiscount, finalDiscount:_finalDiscount, finalDiscountDiscountOnly:_finalDiscountDiscountOnly}
  }

  /* autofill*/
  autoFill(){
    // alert("autofill");
    // console.log("meal-chef-selection click");
    const autoFillMeals = [];
    



    $(".design-your-plan-meals-grid-wrap.delivery .product-meal-item[data-chef-sort]").each(function () {
      autoFillMeals.push(this);
    });

    // $.each(autoFillMeals,function(idx, meal){
    //   console.log($(meal).find(".meal-title").html());
    // })
    
    autoFillMeals.sort(function (a, b) {
      var contentA =parseInt( $(a).data('chef-sort'));
      var contentB =parseInt( $(b).data('chef-sort'));
      return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
   });

   
    var missingMealCount = this.options.minMeals - this.getTotalMeals();
   
   if (autoFillMeals.length > 0){
    while (missingMealCount > 0 ){
      $.each(autoFillMeals,function(idx, meal){
        //console.log($(meal).find(".meal-title").html());
        if (missingMealCount > 0){
          var _val = $(meal).find(".design-your-plan-meal-qty").val();
          if (parseInt(_val)==0){
            $(meal).find(".meal-add-cart .add-to-cart-btn").trigger("click");
          } else {
            $(meal).find(".meal-add-cart .qty-plus").trigger("click");
          }
          
          missingMealCount -=1;
          
        }
      })
    }
  }

    $(".order-summary-container-inner .head-title").trigger("click");
      

    if ($(window).width() >= 1024 ){
      $('html, body').animate({

          //scrollTop: $(document).scrollTop() - 800
          scrollTop: $(".design-your-plan-meals-grid-wrap.delivery .extra-fuel-list").offset().top-300
          
      }, 100);
    }


      
  }


  /* autofill by preferences */
  autoFillByPreferencesAvailableMeals(){
    //return this.autoFillByPreferences(false);
  }
  autoFillByPreferences(charge){
    // alert("autofill");
    // console.log("meal-chef-selection click");
    // return;

   

    var menuContainer = $(".design-your-plan-meals-grid-wrap.delivery");


    charge.preferences_fill_meals;
    charge.preferences_fill_extras;

    charge.preferences_fill_meals.forEach((m) => {
      var mealEle =  menuContainer.find("#p_"+m.pid.replace("gid://shopify/Product/",""));
      var _qty2add = m.qty;

      if (mealEle.length >0 ){
        if (_qty2add == 1){
          var _mealQtyEle = $(mealEle).find(".design-your-plan-meal-qty");
          if (isNaN($(_mealQtyEle).val()) || ($(_mealQtyEle).val() == 0)){
            $(mealEle).find(".meal-add-cart .add-to-cart-btn").trigger("click");
          } else {
            _qty2add += parseInt($(_mealQtyEle).val());
            $(_mealQtyEle).val(_qty2add -1);
            $(_mealQtyEle).parent().find(".add-to-cart-btn").removeClass("active");
            $(_mealQtyEle).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
            $(mealEle).find(".meal-add-cart .qty-plus").trigger("click");
          }
          
          
        } else if (_qty2add > 1){
          var _mealQtyEle = $(mealEle).find(".design-your-plan-meal-qty");
        
          $(_mealQtyEle).val(_qty2add -1);
          $(_mealQtyEle).parent().find(".add-to-cart-btn").removeClass("active");
          $(_mealQtyEle).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
          $(mealEle).find(".meal-add-cart .qty-plus").trigger("click");
        }
        
      }
    })

    charge.preferences_fill_extras.forEach((m) => {
      var mealEle =  menuContainer.find("#p_"+m.pid.replace("gid://shopify/Product/",""));
      var _qty2add = m.qty;
      
      if (mealEle.length >0 ){
        if (_qty2add == 1){
          $(mealEle).find(".meal-add-cart .add-to-cart-btn").trigger("click");
          
        } else if (_qty2add > 1){
          var _mealQtyEle = $(mealEle).find(".design-your-plan-meal-qty");
        
          $(_mealQtyEle).val(_qty2add -1);
          $(_mealQtyEle).parent().find(".add-to-cart-btn").removeClass("active");
          $(_mealQtyEle).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
          $(mealEle).find(".meal-add-cart .qty-plus").trigger("click");
        }
        
      }
    })
    


    /*
    var missingMealCount = this.options.minMeals;
    var mealsToFill = [];
    var extraToFill = [];

    // this.data.meals = [];
    // this.data.extras = [];


    var allAvailableMeals = [];
    $(".design-your-plan-meals-grid-wrap.delivery .product-meal-item").each(function () {
      if (isNaN($(this).data("product-id"))){
      } else {
        allAvailableMeals.push($(this).data("product-id").toString());
      }
    });

    var availablePreferredMeals = this.options.preferredMeals.filter((m) => {
      // console.log(allAvailableMeals);
      // console.log(m.id);
      return allAvailableMeals.includes(m.id.toString())
    });
    
    var availablePreferredExtras = this.options.preferredExtras.filter((m) => {
      // console.log(allAvailableMeals);
      // console.log(m.id);
      return (allAvailableMeals.includes(m.id.toString()) && (m.included_every_week == "true"))
    });

    mealsToFill = availablePreferredMeals.map((m) => {
      var _pname = "";
      $(".design-your-plan-meals-grid-wrap.delivery .product-meal-item").each(function () {
        if (isNaN($(this).data("product-id"))){
        } else {
          if ($(this).data("product-id") == m.id){
            _pname = $(this).data("product-name");
          }
        }
      });
      return {"pid":m.id, "pname":_pname, "qty":m.quantity,"title":m.title, "img":m?.featuredMedia?.image?.url}
    });
    extraToFill = availablePreferredExtras.map((m) => {
      var _pname = "";
      $(".design-your-plan-meals-grid-wrap.delivery .product-meal-item").each(function () {
        if (isNaN($(this).data("product-id"))){
        } else {
          if ($(this).data("product-id") == m.id){
            _pname = $(this).data("product-name");
          }
        }
      });
      return {"pid":m.id, "pname":_pname, "qty":m.quantity,"title":m.title, "img":m?.featuredMedia?.image?.url}
    });
    

    if (addToCart){
      mealsToFill.forEach((m) => {
        if (missingMealCount > 0){
          var _qty2add = parseInt(m.qty);
          if (_qty2add >= missingMealCount){
            _qty2add = missingMealCount;
          }


          var mealEle =  menuContainer.find("#p_"+m.pid);

          if (mealEle.length >0 ){
            if (_qty2add == 1){
              $(mealEle).find(".meal-add-cart .add-to-cart-btn").trigger("click");
              
            } else if (_qty2add > 1){
              var _mealQtyEle = $(mealEle).find(".design-your-plan-meal-qty");
            
              $(_mealQtyEle).val(_qty2add -1);
              $(_mealQtyEle).parent().find(".add-to-cart-btn").removeClass("active");
              $(_mealQtyEle).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
              $(mealEle).find(".meal-add-cart .qty-plus").trigger("click");
            }
            
          }

          missingMealCount -= _qty2add;

        }
      })

      extraToFill.forEach((m) => {
        var mealEle =  menuContainer.find("#p_"+m.pid);
          var _qty2add = parseInt(m.qty);
          
          if (mealEle.length >0 ){
            if (_qty2add == 1){
              $(mealEle).find(".meal-add-cart .add-to-cart-btn").trigger("click");
              
            } else if (_qty2add > 1){
              var _mealQtyEle = $(mealEle).find(".design-your-plan-meal-qty");
            
              $(_mealQtyEle).val(_qty2add -1);
              $(_mealQtyEle).parent().find(".add-to-cart-btn").removeClass("active");
              $(_mealQtyEle).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
              $(mealEle).find(".meal-add-cart .qty-plus").trigger("click");
            }
            
          }
      })
    }

    if (missingMealCount > 0){
      //still missing

      //add meal by preferences, goals, dietary, portion, price range
      const autoPreferencesFillMeals = [];
      $(".design-your-plan-meals-grid-wrap.delivery .product-meal-item").each(function () {
        if (parseInt($(this).data("sort-score")) > 2000){
          if ($(this).hasClass("meal-item-promo-block") || $(this).hasClass("filter-matched-heading") || $(this).hasClass("filter-non-matched-heading")){

          } else {
            autoPreferencesFillMeals.push(this);
          }
        }
      });
      

    //  console.log("this.options");
    //  console.log(this.options);
    
    if (autoPreferencesFillMeals.length > 0){
      while (missingMealCount > 0 ){
        $.each(autoFillMeals,function(idx, meal){
          //console.log($(meal).find(".meal-title").html());
          if (missingMealCount > 0){
            var _val = $(meal).find(".design-your-plan-meal-qty").val();
            if (parseInt(_val)==0){
              $(meal).find(".meal-add-cart .add-to-cart-btn").trigger("click");
              console.log("missingMealCount: "+missingMealCount+" --->add-to-cart-btn click"+_val+" ---->"+$(meal).find(".design-your-plan-meal-qty").attr("id"));
            
            } else {
              $(meal).find(".meal-add-cart .qty-plus").trigger("click");

              console.log("missingMealCount: "+missingMealCount+" --->qty-plus click"+_val+" ---->"+$(meal).find(".design-your-plan-meal-qty").attr("id"));
            }
            
            missingMealCount -=1;
            
          }
        })
      }
    } else {
      //use auto fill if not goals
      this.autoFill();
    }
  }

  */

 
    $(".order-summary-container-inner .head-title").trigger("click");
      

    if ($(window).width() >= 1024 ){
      $('html, body').animate({

          //scrollTop: $(document).scrollTop() - 800
          scrollTop: $(".extra-fuel-list").offset().top-300
          
      }, 100);
    }

    //return {"extraToFill":extraToFill, "mealsToFill":mealsToFill}
  }

  /*meal functions*/
  updateAddedMeals(vid,title,price,qty){
    if (!this.data?.meals){
      this.data.meals = [];
    }
    var isNewMeal = true;
    var _meals = [...this.data.meals].map((ele) => {
      if (ele.vid == vid){
        ele.qty = qty;  
        isNewMeal = false;
      }
      return ele;
    }).filter((ele) => (ele.qty > 0));
    
    isNewMeal && (qty > 0)&& _meals.push({vid,qty});
    
    this.data.meals = _meals;
    $(".meal-add-cart").removeClass("add-more-disabled");
    $(".added-detail-summary").removeClass("add-more-disabled");
    if (!this.isAllowAddMeal()){
      $(".main-meal-selection .design-your-plan-meals-grid-wrap .meal-add-cart").addClass("add-more-disabled");
                
      $(".added-detail-summary").addClass("add-more-disabled");
    }
    
    
    window.designYourPlan.saveData();
    this.updateOrderSummaryUI();
  }
  updateAddedExtras(vid,title,price,qty){
    if (!this.data?.extras){
      this.data.extras = [];
    }
    var isNewExtra = true;
    var _extras = [...this.data.extras].map((ele) => {
      if (ele.vid == vid){
        ele.qty = qty;  
        isNewExtra = false;
      }
      return ele;
    }).filter((ele) => (ele.qty > 0));
    
    isNewExtra && (qty > 0)&& _extras.push({vid,qty});
    
    this.data.extras = _extras;
    
    window.designYourPlan.saveData();
    this.updateOrderSummaryUI();
  }
  isAllowAddMeal(){
     return !(this.getTotalMeals() >= this.options.maxMeals);
  }
  isReachMin(){
    return (this.getTotalMeals() >= this.options.minMeals);
  }
  getTotalMeals(){
    if (window.designYourPlan.mealPicker.data?.meals){
      return window.designYourPlan.mealPicker.data.meals.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.qty),0);
    }
    return 0;
  }
  getTotalNutritionalInfo(){
    let totalCalorie = 0;
    let totalProtein = 0;
    let totalFat = 0;
    let totalCarb = 0;

    for (var i = 0; i<this.data.meals.length;i++){

      var _mealObject = this.findMealObject(false, this.data.meals[i].vid);
      var _qty = parseInt(this.data.meals[i].qty);
        
      var _cal = parseFloat($(_mealObject).parent().data("kcal")); 
      if (isNaN(_cal)) _cal = 0;
      totalCalorie += (_cal*_qty);

      var _protein = parseFloat($(_mealObject).parent().data("protein")); 
      if (isNaN(_protein)) _protein = 0;
      totalProtein += (_protein*_qty);

      var _fat = parseFloat($(_mealObject).parent().data("fat")); 
      if (isNaN(_fat)) _fat = 0;
      totalFat += (_fat*_qty);

      var _carb = parseFloat($(_mealObject).parent().data("carb")); 
      if (isNaN(_carb)) _carb = 0;
      totalCarb += (_carb*_qty);
      
    }

    return {
      "meals":{
        "total":this.getTotalMeals(),
        "calorie":totalCalorie,
        "fat":totalFat,
        "protein":totalProtein,
        "carb":totalCarb
      }
    }
    
  }


  //discount
  genDiscountText(discount){
    var discountText = discount.code;
    if (discount.customerGets.value.__typename == "DiscountAmount"){
      discountText = "-£"+discount.customerGets.value.amount.amount;
      
    }
    if (discount.customerGets.value.__typename == "DiscountPercentage"){
      discountText = (parseFloat(discount.customerGets.value.percentage)*100)+"% off";
    }
    $(".detail-total-container .discounts .code").append('<div>'+discount.code+' ('+discountText+')<span class="del" onclick="window.designYourPlan.mealPicker.removeDiscountCode(this, \''+discount.code+'\')"></span></div>');

  }
  useRechargeDiscount(discount){
    if (discount?.length >0){
      var discountVal = {};
      if (discount[0].hasOwnProperty("value_type")){
        if (discount[0].value_type == "percentage"){
          discountVal = {
            percentage:discount[0].value,
            __typename:"DiscountPercentage"
          };
        }
      }

      if (discount[0].hasOwnProperty("type")){
        if (discount[0].type == "fixed_amount"){
          discountVal = {
            amount:{
              amount: discount[0].amount
            },
            __typename:"DiscountAmount"
          };
        }
      }

      this.data.discounts = [{
        code:discount[0].code,
        combinesWith:{orderDiscounts:false,productDiscounts:false,shippingDiscounts:false},
        customerGets:{
          items:{
            allitems:true,
            __typename:"AllDiscountItems"
          },
          value:discountVal
        }
      }]; 
    } else {
      this.data.discounts = [];
    }
  }
  async removeDiscountCode(which, code){
    if (this.options.customerType == this.customerTypes.subscriber){
      
      var _parent = $(which).parent();
      $(which).remove();
      _parent.append('<span class="spinner"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><style>.spinner_P7sC{transform-origin:center;animation:spinner_svv2 .75s infinite linear}@keyframes spinner_svv2{100%{transform:rotate(360deg)}}</style><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_P7sC"></path></svg></span>');
      
      const session = await recharge.auth.loginShopifyAppProxy();
      
      const res = await recharge.address.removeDiscountsFromAddress(session, window.designYourPlan.data.charge.address_id);
      //console.log(res);
      //remove recharge charge promo code
      if (res.hasOwnProperty("discounts") && res.discounts.length <= 0){
        window.designYourPlan.data.charge.discount_codes = [];
      }

  
    }
    window.designYourPlan.mealPicker.data.discounts = [...window.designYourPlan.mealPicker.data.discounts.filter((item) => {
      return code != item.code;
    })];

    window.designYourPlan.saveData();
    window.designYourPlan.updateUI();
  }
  async applyDiscountCode(code){
    if (code == "") return;
    // console.log("applyDiscountCode: "+code);
    // console.log(window.designYourPlan.mealPicker.data.busy);
    
    if (window.designYourPlan.mealPicker.data.busy) return;
    


    window.designYourPlan.mealPicker.data.busy = true;
    
    
    
    $(".order-summary-discount").find(".code").addClass("loading");
    // console.log("applyDiscountCode");
    // console.log(code);
    var _data = {"code":code};
    



    if (this.options.customerType == this.customerTypes.subscriber){

      const session = await recharge.auth.loginShopifyAppProxy();
      const res = await recharge.address.applyDiscountToAddress(session, window.designYourPlan.data.charge.address_id, code);
          
      
      let formData = new FormData();
      //use recharge object ReCharge.Novum
      
      formData.append("action", "getData");
      formData.append("type", "shopify");
      formData.append("id", window.dyp.shopify.customer.id); // shopify customer id
      formData.append("email", window.dyp.shopify.customer.email ); // shopify customer email
      formData.append("hash", window.dyp.shopify.customer.hash ); // shopify hash
      formData.append("subs_id", window.designYourPlan.data.subscription.id); // subscription id
      
      setTimeout(async function(){
        await fetch(window.designYourPlan.mealPicker.options.apiUrl+"subs_upcoming_charges", {
        //await fetch("http://localhost:8080/design_your_plan/subs_upcoming_charges", {
          method: "POST",
          //mode: "no-cors", // no-cors, *cors, same-origin
          cache: "no-cache",
          // *default, no-cache, reload, force-cache, only-if-cached
          //credentials: "same-origin", // include, *same-origin, omit
          body: formData,
          //headers: {'Accept': 'application/json','Content-Type': 'application/json'},
        }).then((response) => response.json()).then((data) => {
          if ((data.hasOwnProperty("data")) && (data.data.hasOwnProperty("charges")) && (data.data.hasOwnProperty("subscription")) && (data.data.subscription.hasOwnProperty("id"))){
            
            
            for (const [key, charge] of Object.entries(data.data.charges)) {
              if (charge.id == window.designYourPlan.data.charge.id){
                window.designYourPlan.data.charges = data.data.charges;
                window.designYourPlan.data.charge = charge;
                window.designYourPlan.mealPicker.useRechargeDiscount(charge.discount_codes);
                window.designYourPlan.updateUI();
                $(".order-summary-discount").find(".code").removeClass("loading");
                window.designYourPlan.mealPicker.data.busy = false;
                $("#order-summary-discount-code").val("");
        
              }
            }

            
          }
        }).catch((error) => {
          console.log(error);
          alert("error");
        });
      
      }, 10000)
        
      return; 
    }

    let formData = new FormData();
    formData.append("action", "check");
    formData.append("data", JSON.stringify(_data));
    formData.append("shop", "fuelhub.myshopify.com");


    await fetch(window.designYourPlan.mealPicker.options.apiUrl+"discount", {
      method: "POST",
      //mode: "no-cors", // no-cors, *cors, same-origin
      cache: "no-cache",
      // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: "same-origin", // include, *same-origin, omit
      body: formData,
      //headers: {'Accept': 'application/json','Content-Type': 'application/json'},
    }).then((response) => response.json()).then((data) => {
      // console.log(data);
      if (data.data.success != "true"){
        $("#order-summary-discount-code").val("");
        $("#order-summary-discount-code-err").html("invalid promo code");
        $("#order-summary-discount-code-err").show();
        setTimeout(function(){
          $("#order-summary-discount-code-err").hide();
        }, 2000);
      } else {
        $("#order-summary-discount-code").val("");
        var canApply = true;
        var errMsg = "";
        $.each(window.designYourPlan.mealPicker.data.discounts, function( index, value ) {
          //check same promo code applied?
          if (value.code == data.data.data["code"]){
            canApply = false;
            errMsg = "promo code applied";
          } else if ( !data.data.data.combinesWith.orderDiscounts && !data.data.data.combinesWith.productDiscounts ){
            canApply = false;
            errMsg = "you cannot combine these promo code";
          } else if (value.customerGets.items.__typename == data.data.data.customerGets.items.__typename){
            canApply = false;
            errMsg = "you cannot combine two same promo type";
          } 
        });
        
        if (canApply && (data.data.data)){
          //check duplicate promo type
          $.each(window.designYourPlan.mealPicker.data.discounts, function( index, value ) {
            if (value.customerGets.items.__typename == data.data.data["customerGets"]["items"]["__typename"]){
              canApply = false;
              errMsg = "only one promo type is allowed";
            }
          });
        }
        
        
        if (canApply){  
          if (!window.designYourPlan.mealPicker.data?.discounts){
            window.designYourPlan.data.mealPicker.discounts = [];
          }
          window.designYourPlan.mealPicker.data.discounts.push(data.data.data);
          window.designYourPlan.mealPicker.data.busy = false;
          window.designYourPlan.updateUI();
        } else {
          $("#order-summary-discount-code").val("");
          $("#order-summary-discount-code-err").html(errMsg);
          $("#order-summary-discount-code-err").show();
          setTimeout(function(){
            $("#order-summary-discount-code-err").hide();
          }, 2000);
        }
      }
      
      $(".order-summary-discount").find(".code").removeClass("loading");
      window.designYourPlan.mealPicker.data.busy = false;
      
    
    }).catch((error) => {
      console.log(error);
      $(".order-summary-discount").find(".code").removeClass("loading");
      window.designYourPlan.mealPicker.data.busy = false;
      
    
    });

  }



  gotoMeal(vid){
    // $([document.documentElement, document.body]).animate({
    //     scrollTop: $(".design-your-plan-meals-grid-wrap.delivery #"+vid).parent().offset().top - 50
    // }, 300);
    
  }
  orderSummayMinusHandle(vid){
    var activeMenuObj = $(".design-your-plan-meals-grid-wrap.delivery");
    $(activeMenuObj).find("#"+vid).parent().find(".qty-minus").trigger("click");
  }
  orderSummayPlusHandle(vid){
    var activeMenuObj = $(".design-your-plan-meals-grid-wrap.delivery");
    $(activeMenuObj).find("#"+vid).parent().find(".qty-plus").trigger("click");
  }
  orderSummayExtraMinusHandle(vid){
    var activeMenuObj = $(".design-your-plan-meals-grid-wrap.delivery");
    $(activeMenuObj).find("#"+vid).parent().find(".qty-minus").trigger("click");
  }
  orderSummayExtraPlusHandle(vid){
    var activeMenuObj = $(".design-your-plan-meals-grid-wrap.delivery");
    $(activeMenuObj).find("#"+vid).parent().find(".qty-plus").trigger("click");
  }
  isSameMenu(newDeliveryDate){
    var currentDeliveryDate = new Date(window.designYourPlan.data.delivery.date);
    
    var currentDeliveryDateMenuIdx = -1;
    var nextDeliveryDateMenuIdx = -1;
    $(".design-your-plan-menu-date-tab").each(function(idx){
      var menuStartDate = new Date($(this).data("startdate"));
      var menuEndDate = new Date($(this).data("enddate"));
      
      if (currentDeliveryDate >= menuStartDate && currentDeliveryDate <= menuEndDate){
          currentDeliveryDateMenuIdx = idx;
      }
      if (newDeliveryDate >= menuStartDate && newDeliveryDate <= menuEndDate){
          nextDeliveryDateMenuIdx = idx;
      }
    })
    
    return currentDeliveryDateMenuIdx == nextDeliveryDateMenuIdx;

  }
  clearPlanData(){
    $(".design-your-plan-meal-qty").each(function () {
      $(this).val(0);
      $(this).trigger("change");
    });
    this.data.meals = [];
    this.data.extras = [];
    
  }
  
  setDeliveryDate(selectDelivery){
    console.log("setDeliveryDate");
    console.log(selectDelivery);
    
    const selectDeliveryData = new Date(selectDelivery.date);
    const selectDeliveryDataTS = selectDeliveryData.getTime();
    const dateString = selectDelivery.date;//(selectDeliveryData.getMonth()+1) + "/" +  selectDeliveryData.getFullDate() + "/" + selectDeliveryData.getFullYear();
    const dayString = selectDelivery.day;
    
    //console.log(dateString);
    $(".order-summary-delivery-date").val(selectDelivery.date);
    
    $(".design-your-plan-menu-date-tab").removeClass("delivery");
    $(".design-your-plan-menu-date-tab").removeClass("active");
    $(".design-your-plan-meals-grid-wrap").removeClass("delivery");
    $(".design-your-plan-meals-grid-wrap .meal-add-cart").hide();

    
    var availableMenus = $(".design-your-plan-menu-date-tab").length;
    // console.log("availableMenus");
    // console.log(availableMenus);
    for (var i=1;i<=availableMenus;i++){
      var menuStartDateTS = new Date($("#design-your-plan-menu-date-tab-"+i).data("startdate")).getTime();
      var menuEndDateTS = new Date($("#design-your-plan-menu-date-tab-"+i).data("enddate")).getTime();
      // console.log(i+" : "+menuStartDateTS+" : "+menuEndDateTS+" : "+selectDeliveryDataTS);
      if (selectDeliveryDataTS>=menuStartDateTS && selectDeliveryDataTS<=menuEndDateTS ){
        // console.log("change to "+i);
        $("#design-your-plan-menu-date-tab-"+i).addClass("active");
        $("#design-your-plan-menu-date-tab-"+i).addClass("delivery");
        //$("#design-your-plan-menu-date-tab-"+i).trigger("click");
        $("#design-your-plan-menu-"+i).addClass("delivery");
        $("#design-your-plan-menu-"+i+" .meal-add-cart").show();
        this.data.delivery = {"date":dateString, "day":dayString};
        
      }
    }


    //handle product list for special date, easter 5 Apr 2026
    var _hideSkus = ["B1", "F26", "F27"];
    if (selectDelivery.date == "04/05/2026"){
      $(".design-your-plan-meals-grid-wrap.delivery").find(".product-meal-item").each(function(){
        var _sku = $(this).data("sku");
        if (_hideSkus.indexOf(_sku) > -1){
          $(this).hide();
        }
        
      });
      if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
      

        $(".design-your-plan__delivery-notes .extra-notes").show();
        // $("#design-your-plan__dialog-container .dialog-close").show();
        // $("#design-your-plan__dialog-container .dialog-btns-container").hide();


        // var _loadingSpinner = `<center><span class="spinner"><img width="50" height="auto" src="https://cdn.shopify.com/s/files/1/0728/3802/1419/files/Flame_2.svg?v=1750695388" alt="FuelHub"></span><br/></center>`;
        // $(".dialog-content-container").html(_loadingSpinner+"<span style='color:#ffc03b'>IMPORTANT (!)</span><br />*Our usual delivery day is Sunday. However, due to DPD’s limited service over the Easter weekend, your delivery will arrive on Saturday 4th April.")
        // $("#design-your-plan__dialog-container").show();
      }

    } else {
      $(".design-your-plan-meals-grid-wrap.delivery").find(".product-meal-item").each(function(){
        var _sku = $(this).data("sku");
        if (_hideSkus.indexOf(_sku) > -1){
          $(this).show();
        }
        
      });
      $(".design-your-plan__delivery-notes .extra-notes").hide();
    }
    
  }


  /*upsell*/
  initUpsell(){
    $("#design-your-plan__upsell-container .dialog-close").click(function(){
      window.designYourPlan.mealPicker.closeUpsell();
    })
    
    $("#upsell-btn-cancel").click(function(){
      window.designYourPlan.mealPicker.processUpsellCancel();
    });
    
    $("#upsell-btn-ok").click(function(){
      //window.designYourPlan.mealPicker.processUpsellAction();
      window.designYourPlan.mealPicker.checkout();
      window.designYourPlan.mealPicker.closeUpsell();
      
    });
  }
  handleUpsell(){

    // window.upsellPopup = "Yes";

    $("#design-your-plan__upsell-container").removeClass("one-time");
    $("#design-your-plan__upsell-container").removeClass("subscribe");
    $("#design-your-plan__upsell-container").addClass(window.designYourPlan.mealPicker.data.type);
    
    //swiper
    const _upsell_extras_products = $("#upsell-extras-collection-wrapper").find(".product-meal-item").shuffle();
    //alert(_upsell_extras_products.length);

    const _upsell_meals_products = $("#upsell-meals-collection-wrapper").find(".product-meal-item").shuffle();
    
    
    swiper.destroy();
   
    var _upsell_items_count = 0;
    var _upsell_items = [];
    //remove all update items
    $(".swiper-wrapper").html("");
    
    if (_upsell_extras_products.length >0){
      //verify upsell collection product and add to upsell container
      var count = 0;
      $(_upsell_extras_products).each(function(){
        if (count<3){
          //var _upsell_item = $(this).clone(true, true);
          var _upsell_item = $(this).clone();

          var _upsell_item_vid = $(_upsell_item).find(".design-your-plan-meal-qty").attr("id");
          var _added = false;
          window.designYourPlan.mealPicker.data.extras.forEach((e) => {
            if (e.vid == _upsell_item_vid){
              _added = true;
            }
          })
          if (!_added){
            $(".swiper-wrapper").append($('<div class="swiper-slide" role="group" />').append(_upsell_item));
            count+=1;
            _upsell_items_count +=1;
            _upsell_items.push(_upsell_item_vid);
          }
        }
      });
    }

    if (_upsell_meals_products.length >0){
      //verify upsell collection product and add to upsell container
      var count = 0;
      $(_upsell_meals_products).each(function(){
        if (count<3){
          //var _upsell_item = $(this).clone(true, true);
          var _upsell_item = $(this).clone();

          var _upsell_item_vid = $(_upsell_item).find(".design-your-plan-meal-qty").attr("id");
          var _added = false;
          window.designYourPlan.mealPicker.data.meals.forEach((e) => {
            if (e.vid == _upsell_item_vid){
              _added = true;
            }
          })
          if (!_added){
            $(".swiper-wrapper").append($('<div class="swiper-slide" role="group" />').append(_upsell_item));
            count+=1;
            _upsell_items_count +=1;
            _upsell_items.push(_upsell_item_vid);
          }
        }
      });
    }

    const _upsell_filterd_meals = $(".design-your-plan-meals-grid-wrap.delivery .meal-list").find(".product-meal-item");
    
    if (_upsell_filterd_meals.length >0){
      //add upsell meals product and add to upsell container
      var count = 0;
      $(_upsell_filterd_meals).each(function(){
        if ($(this).hasClass("filter-matched-heading") || $(this).hasClass("filter-non-matched-heading") || $(this).hasClass("meal-item-promo-block")){
        } else {
          if (count<3){
            //var _upsell_item = $(this).clone(true, true);
            var _upsell_item = $(this).clone();

            var _upsell_item_vid = $(_upsell_item).find(".design-your-plan-meal-qty").attr("id");
            var _added = false;
            window.designYourPlan.mealPicker.data.meals.forEach((e) => {
              if (e.vid == _upsell_item_vid){
                _added = true;
              }
            })
            if (_upsell_items.includes(_upsell_item_vid)){
              _added = true;
            }

            if (!_added){
              $(".swiper-wrapper").append($('<div class="swiper-slide" role="group" />').append(_upsell_item));
              count+=1;
              _upsell_items_count +=1;
            }
          }
        }
      });
    }
    
    
    if ($("#design-your-plan__upsell-container").find(".product-meal-item").length > 0){
      if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
        // removed 20 Aug 2026
        // if (typeof gtag !== "undefined") { 
        //   // safe to use the function
        //   console.log("gtag ready");
        //   gtag('event', "OnboardingJourney", {
        //     plan_type: window.designYourPlan.data.plan.type,
        //     pageUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell",
        //     pageTitle:"Onboardeing - Upsell",
        //     previousUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals"
        //   });
        //   gtag('event', "Onboarding_Upsell", {
        //     plan_type: window.designYourPlan.data.plan.type,
        //     pageUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell",
        //     pageTitle:"Onboardeing - Upsell",
        //     previousUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals"
        //   });
        //   // window.dataLayer.push({
        //   //   'event': 'virtualPageview',
        //   //   'pageUrl': "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell",
        //   //   'pageTitle':"Onboardeing - Upsell",
        //   //   'previousUrl': "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals"
        //   // });
        // } else {
        //   console.log("gtag missing");
        // }
      }
      window.updateSwiper();


    $("#design-your-plan__upsell-container .product-meal-item .add-to-cart-btn").on("click", function () {
      console.log("upsell add-to-cart-btn click");
      
      var $this = $(this);    
      var isExtra = $this.parents(".product-meal-item").hasClass("extra-meal");
      if (isExtra || window.designYourPlan.mealPicker.isAllowAddMeal()){
          var mealQty = $this.parents(".product-meal-item").find(".design-your-plan-meal-qty");
      
          mealQty.val(1).trigger("change");
          $this.removeClass("active");
          $this.next().addClass("active");
      }
      
    });

    $("#design-your-plan__upsell-container .design-your-plan-qty-selection-wrap .qty-minus").on("click", function (e) {

      console.log("upsell qty-mins click");
      
      var mealQty = $(this).parents(".product-meal-item").find(".design-your-plan-meal-qty");
      var qtyVal = mealQty.val();
  
      if (qtyVal > 0) {
        mealQty.val(parseInt(qtyVal) - 1).trigger("change");
  
        if (qtyVal == 1) {
          $(this).parent().removeClass("active");
          $(this).parent().prev().addClass("active");
        } else {
          $(this)
            .next()
            .find(".value")
            .text(parseInt(qtyVal) - 1);
        }
        
        // Update text based on new quantity
        var newQty = parseInt(qtyVal) - 1;
        if (newQty == 1) {
          //$(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meal");
          $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty);
        } else if (newQty > 1) {
          //$(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meals");
          $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty);
        }
        

      }
    });
  
    $("#design-your-plan__upsell-container .design-your-plan-qty-selection-wrap .qty-plus").on("click", function () {
      console.log("upsell qty-plus click");
      
      var $this = $(this);    
      var isExtra = $this.parents(".product-meal-item").hasClass("extra-meal");
      if (isExtra || window.designYourPlan.mealPicker.isAllowAddMeal()){
      
        
        var mealQty = $(this).parents(".product-meal-item").find(".design-your-plan-meal-qty");
        var qtyVal = mealQty.val();
    
        mealQty.val(parseInt(qtyVal) + 1).trigger("change");
  
        $(this)
          .prev()
          .find(".value")
          .text(parseInt(qtyVal) + 1);
          
        // Update text based on new quantity
        // var newQty = parseInt(qtyVal) + 1;
        // if (newQty == 1) {
        //   $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meal");
        // } else if (newQty > 1) {
        //   $(this).parents(".product-meal-item").find(".design-your-plan-qty-selection-wrap .bold").text(newQty + " meals");
        // }
          

      }
    });
    
      $("#design-your-plan__upsell-container .design-your-plan-meal-qty").each(function () {
        
        var $this = $(this);
        //meal qty change
        var mealQtyCtrler = () => {
          console.log("mealQtyCtrler");
          var addedMeal = $this;
          var itemWrap = addedMeal.parent(".product-meal-item");
          var mealVariantID = addedMeal.attr("id");
          var mealTitle = addedMeal.data("title");
          var mealPrice = addedMeal.data("price");
          
          
          if (addedMeal.val() == 0){
            $this.parent().find(".add-to-cart-btn").addClass("active");
            $this.parent().find(".design-your-plan-qty-selection-wrap").removeClass("active");
          }
          
          
          
          // Update text based on quantity
          if (addedMeal.val() == 1){
            //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val() + " meal");
            $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val());
          } else if (addedMeal.val() > 1){
            //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val() + " meals");
            $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text(addedMeal.val());
          }
          
          if (addedMeal.val() <= 1){
            $this.parent().find(".design-your-plan-qty-selection-wrap").find(".value").val("1");
          }
          $(".design-your-plan-meals-grid-wrap.delivery").find(".design-your-plan-meal-qty").each(function(){
            var _vid = $(this).attr("id");
            if (_vid == mealVariantID){
              $(this).val(addedMeal.val());
              $(this).trigger("change");
              if (addedMeal.val() == 0){
                $(this).parent().find(".add-to-cart-btn").addClass("active");
                $(this).parent().find(".design-your-plan-qty-selection-wrap").removeClass("active");
              } else {
                $(this).parent().find(".add-to-cart-btn").removeClass("active");
                $(this).parent().find(".design-your-plan-qty-selection-wrap").addClass("active");
              }
              window.designYourPlan.mealPicker.data.upsellItems.push({vid:_vid});
            }
          });
          
        };
    
        $this.change(function () {
          mealQtyCtrler();
        });
        
        // Initialize text on page load for meals that already have quantity
        setTimeout(() => {
          if ($this.val() > 0) {
            console.log("Initializing text for meal with qty:", $this.val());
            if ($this.val() == 1) {
              //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val() + " meal");
              $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val());
            } else if ($this.val() > 1) {
              //$this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val() + " meals");
              $this.parent().find(".design-your-plan-qty-selection-wrap .bold").text($this.val());
            }
          }
        }, 50);
        

      });

      $("#design-your-plan__upsell-container").show();
      //$("body").addClass("overflow-y-hidden"); 
      
    } else {
      window.designYourPlan.mealPicker.checkout();
    }



    // if ($("#design-your-plan__upsell-container").find(".product-meal-item").length > 0){
    //   var count = 0;
    //   $("#design-your-plan__upsell-container").find(".product-meal-item").each(function(){
    //     $(this).hide();
    //     if (count < 3){
    //       var found = false;
    //       for( const extra of window.designYourPlan.mealPicker.data.extras){
    //         if ($(this).find(".design-your-plan-meal-qty").attr("id") == extra.vid){
    //           $(this).hide();
    //           found = true;
    //         } 
    //       }
    //       if (!found){
    //         $(this).show();
    //         count++;
    //       }
    //     }
    //   });
      
    //   if (count > 0){
    //     if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
    //       if (typeof gtag !== "undefined") { 
    //         // safe to use the function
    //         console.log("gtag ready");
    //         gtag('event', "OnboardingJourney", {
    //           plan_type: window.designYourPlan.data.plan.type,
    //           pageUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell",
    //           pageTitle:"Onboardeing - Upsell",
    //           previousUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals"
    //         });
    //         gtag('event', "Onboarding_Upsell", {
    //           plan_type: window.designYourPlan.data.plan.type,
    //           pageUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell",
    //           pageTitle:"Onboardeing - Upsell",
    //           previousUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals"
    //         });
    //         // window.dataLayer.push({
    //         //   'event': 'virtualPageview',
    //         //   'pageUrl': "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell",
    //         //   'pageTitle':"Onboardeing - Upsell",
    //         //   'previousUrl': "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals"
    //         // });
    //       } else {
    //         console.log("gtag missing");
    //       }
    //     }
    //     window.updateSwiper();
    
    //     $("#design-your-plan__upsell-container").show();
    //     $("body").addClass("overflow-y-hidden"); 

    //   } else {
    //     window.designYourPlan.mealPicker.checkout();
    //   }
      
    // } else {
    //   window.designYourPlan.mealPicker.checkout();
    // }
    
  }
  closeUpsell(){
    $("#design-your-plan__upsell-container").hide();
    //$("body").removeClass("overflow-y-hidden");
    
  }
  processUpsellCancel(){
    
    window.designYourPlan.mealPicker.closeUpsell();
  }
  processUpsellAction(){
    window.designYourPlan.mealPicker.closeUpsell();
    window.designYourPlan.mealPicker.checkout();
  }

  /*preview*/
  initPreview(){
    
  }


  /*checkout*/
  checkout(){
    //console.log("checkout function");
    // skip checkout echo

    // const totalMeals = this.getTotalMeals();
    // const totalExtras = this.data.extras ? this.data.extras.reduce((acc, extra) => acc + parseInt(extra.qty), 0) : 0;
    // console.log('=== CHECKOUT CLICKED ===');
    // console.log('Total selected meals:', totalMeals);
    // console.log('Total selected extras:', totalExtras);
    // console.log('Total items (meals + extras):', totalMeals + totalExtras);
    // console.log('Meals data:', this.data.meals);
    // console.log('Extras data:', this.data.extras);
    // console.log('========================');
    
    window.designYourPlan.checkout();
  }

  getCheckoutParams(){
    let reversedParams = [];
    let dietaryPreference = "All";

    let planProduct;
    let upsellItems = this.data.upsellItems;
    for (let i = this.data.extras.length - 1; i >= 0; i--) {
      let isUpsell = false;
      let _vid = this.data.extras[i].vid;
      upsellItems.forEach((u) =>{
        if (u.vid == _vid){
          isUpsell = true;
        }
      })
      if (isUpsell){
        //add upsell attribute
        if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
          reversedParams.push({id: this.data.extras[i].vid,quantity:this.data.extras[i].qty, properties: {'_upsell': 'Yes'}});
        } else {
          reversedParams.push({id: this.data.extras[i].vid,quantity:this.data.extras[i].qty, properties: [{ "name":'_upsell', "value": 'Yes'}]});
        }
        
      } else {
        reversedParams.push({id: this.data.extras[i].vid,quantity:this.data.extras[i].qty});
      }
      //reversedParams.push({id: this.data.extras[i].vid,quantity:this.data.extras[i].qty});
      

    }
    for (let i = this.data.meals.length - 1; i >= 0; i--) {
      let isUpsell = false;
      let _vid = this.data.meals[i].vid;
      
      upsellItems.forEach((u) =>{
        if (u.vid == _vid){
          isUpsell = true;
        }
      })
      if (isUpsell){
        //add upsell attribute
        if (window.designYourPlan.mealPicker.options.customerType == window.designYourPlan.mealPicker.customerTypes.new){
          reversedParams.push({id: this.data.meals[i].vid,quantity:this.data.meals[i].qty, properties: {'_upsell': 'Yes'}});
        } else {
          reversedParams.push({id: this.data.meals[i].vid,quantity:this.data.meals[i].qty, properties: [{ "name":'_upsell', "value": 'Yes'}]});
        }
      } else {

        
        reversedParams.push({id: this.data.meals[i].vid,quantity:this.data.meals[i].qty});
      }
      //reversedParams.push({id: this.data.meals[i].vid,quantity:this.data.meals[i].qty});
      
      //testing
      // if( (Math.floor(Math.random() * 10)) > 5){
      //   reversedParams.push({id: 55176441102709,quantity:this.data.meals[i].qty});  
      // } else {
      //   reversedParams.push({id: 55176441790837,quantity:this.data.meals[i].qty}); 
      // }

    }

    
    if (this.data.type == "subscribe"){
      if (this.data.delivery.day == "Wed") {
        planProduct = this.options.planProducts.subscription.wed;
        
      } else if (this.data.delivery.day == "Sun") {
        planProduct = this.options.planProducts.subscription.sun;
        
      } 
      reversedParams.push({id: planProduct.vid,quantity:1, selling_plan:planProduct.sellingPlan});
      
    } else {
      if (this.data.delivery.day == "Wed") {
        planProduct = this.options.planProducts.onetime.wed;
        
      } else if (this.data.delivery.day == "Sun") {
        planProduct = this.options.planProducts.onetime.sun;
        
      } 
      reversedParams.push({id: planProduct.vid,quantity:1});
    } 
    

    if ($('[data-tag="gluten free"]').hasClass("clicked")) {
      dietaryPreference = "Gluten Free";
    } else if ($('[data-tag="dairy free"]').hasClass("clicked")) {
      dietaryPreference = "Dairy Free";
    } else if ($('[data-tag="meat free"]').hasClass("clicked")) {
      dietaryPreference = "Meat Free";
    }

    return {
      items: reversedParams,
      dietaryPreference: dietaryPreference,
      goals: this.options.goals,
      portion: this.options.portion,
      planProduct:planProduct,
      delivery: this.data.delivery,
      discount: this.data.discounts,
      type: this.data.type
    }
    
  
  }
  
  

  
}

document.addEventListener('DOMContentLoaded', function () {
  console.log("DOMContentLoaded");
  const container = document.querySelector('.design-your-plan-meals-selection-container');
  const summary = document.querySelector('.order-summary-container-inner');
  if (!container || !summary) return;

  const offset = 200; // match your CSS top value

  function applyStickyBehavior() {
    if (window.innerWidth >= 1024) {
      summary.style.removeProperty('position');
      summary.style.removeProperty('top');
      summary.style.removeProperty('bottom');
      summary.style.removeProperty('width');
      window.addEventListener('scroll', onScroll);
      onScroll();
    } else {
      // Remove sticky/fixed/absolute styles for mobile/tablet
      summary.style.position = '';
      summary.style.top = '';
      summary.style.bottom = '';
      summary.style.width = '';
      window.removeEventListener('scroll', onScroll);
    }
  }

  function onScroll() {
    if (window.innerWidth < 1024) return;
    const containerRect = container.getBoundingClientRect();
    const summaryRect = summary.getBoundingClientRect();

    if (containerRect.top > offset) {
      // Not yet scrolled to sticky point
      summary.style.position = 'sticky';
      summary.style.top = offset + 'px';
      summary.style.bottom = '';
      summary.style.width = '';
    } else if (containerRect.bottom - summaryRect.height - offset < 0) {
      // At the bottom of the container
      summary.style.position = 'absolute';
      summary.style.top = '';
      summary.style.bottom = '0';
      summary.style.top = 'auto';
      summary.style.width = '100%';
    } else {
      // In sticky mode
      summary.style.position = 'fixed';
      summary.style.top = offset + 'px';
      summary.style.bottom = '';
      summary.style.width = summary.parentElement.offsetWidth + 'px';
    }

    
  }

  $(".order-summary-container-inner .head-title").click(function(){
    if (window.innerWidth < 1024) {
      $('body').toggleClass("overflow-y-hidden");
      $(this).parent().parent().toggleClass("active");
      setTimeout(function(){
        if (!$("#design-your-plan__step-checkout").hasClass("active")){
          $('body').removeClass("overflow-y-hidden");
        }
      }, 500);
    }
    
  });

  $('.order-summary-container').on('click', function (event) {
    if (event.target != this) {
      
    } else {
      $('body').removeClass("overflow-y-hidden");
        $(this).removeClass("active");
    }
  });

  // $(".order-summary-container").clic(function(){
  //   if (window.innerWidth < 1024) {
  //     $('body').removeClass("overflow-y-hidden");
  //     $(this).removeClass("active");
  //   }
  // });

  window.addEventListener('resize', applyStickyBehavior);
  applyStickyBehavior();
});